import React, { useEffect, useState, useRef } from "react";
import { BASE_URL } from "../../global/Provider-Api";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams, useLocation } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import chalk from "chalk";
import dayjs from "dayjs";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import {
  Container,
  Badge,
  Row,
  Col,
  Card,
  Spinner,
  input,
  Form,
  Button,
  Modal as btModal,
} from "react-bootstrap";

import {
  Button as antdButton,
  Drawer,
  Radio,
  Space,
  Skeleton,
  Modal,
  Divider,
  Progress,
  Flex,
  Typography,
} from "antd";

import {
  SwapOutlined,
  CreditCardOutlined,
  CreditCardFilled,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import texts from "./utils/langMessage";
import {
  //PKINDEV
  getPkindevRequest,
  getTermsRequest,
  getPrivacyRequest,
  getRefundRequest,
  //PROJECT
  getProject_request,
  //PROJECT PLAN
  getProject_Plan_request,
  //SUBSCRIPTION PLAN
  getSubscription_Plan_Request,
  //address
  getProvinceOption,
  getDistrictOption,
  getSubdistrictOption,
} from "../../redux/scriptionPlan/actions";

import { getCompanyPkindev, getCreditBank } from "../../redux/actions";

import apiSetting from "../../services/setting";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import SpinnerLoading from "../../components/Loading/SpinnerLoading";
import moment from "moment";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

//form
import CompanyInfoForm from "./CompanyInfoForm";
import BasicInformationForm from "./BasicinfoForm";
import OrganizationForm from "./OrganizationForm";
import CardPlan from "./CardPlan";
import PaymentForm from "./PaymentForm";
//utils
import {
  toastSuccess,
  toastError,
  toastWarning,
} from "./utils/toastNotifications";
import { use } from "react";
import { error } from "jquery";
// Import your SVG
const backgroundSvg = `${process.env.PUBLIC_URL}/assets/Menu&Header/subscription_bg.svg`;
const pkindev_logo_text = `${process.env.PUBLIC_URL}/media/PKINDEV PLATFORM/logo_pics/Project_Dashboard/Text/pkindev_Text.png`;

//Style
const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;700&display=swap');

  @import url('https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

  body {
    font-family: "Prompt", sans-serif;
    font-weight: 200;
    font-style: normal;
  }
  
  .form-control, .form-select {
  height: 40px; /* หรือค่าอื่นที่ต้องการให้เท่ากัน */
  border-radius: 5px;
  border: 1px solid #ced4da;
  }

  .form-control.is-valid{
    border-color: green !important;
  }
  .form-control.is-invalid{
    border-color: red !important;
  }
  .form-select.is-valid {
    border-color: green !important;
  }
  .form-select.is-invalid {
    border-color: red !important;
  }

`;

const theme = createTheme({
  typography: {
    fontFamily: "'Prompt', sans-serif", // เปลี่ยนเป็นฟอนต์ที่ต้องการ
  },
  palette: {
    primary: {
      main: "#CD454B", // สีหลักของธีม (สีแดงโทนที่ระบุ)
    },
  },
  components: {
    MuiStepConnector: {
      styleOverrides: {
        root: {
          top: "25%", // ทำให้เส้นเชื่อมอยู่ตรงกลางของไอคอน
          transform: "translateY(-50%)", // แก้ไขตำแหน่งเส้นให้สมดุล
        },
        line: {
          borderColor: "#d7d7d7", // สีเส้นปะ
          borderWidth: "2px", // ความหนาของเส้น
          borderStyle: "dashed", // ปรับเป็นเส้นปะ
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          fontSize: "40px", // ปรับขนาดไอคอนให้ใหญ่ขึ้น
          color: "#d7d7d7", // สีของไอคอนเมื่อไม่ active
          "&.Mui-active": {
            color: "#CD454B", // สีแดงสำหรับไอคอนที่ active
          },
          "&.Mui-completed": {
            //color: "#4caf50", // สีเขียวเมื่อขั้นตอนเสร็จสมบูรณ์
            color: "#CD454B", // สีเขียวเมื่อขั้นตอนเสร็จสมบูรณ์
          },
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        labelContainer: {
          textAlign: "center", // ทำให้ข้อความ Label อยู่ตรงกลาง
        },
      },
    },
  },
});

const Subscription = (props) => {
  const { Text } = Typography;
  ////////////////////////////////////////////////////////////////
  //////////////////////FOR Developer/////////////////////////////
  ////////////////////////////////////////////////////////////////

  const [MockEmail_select, setMockEmail_select] = useState();
  const mockEmail = [
    "natthadanai.srimuang@gmail.com",
    "nut.za887@gmail.com",
    "nattharagnarok@gmail.com",
  ];
  const selectedEmail = mockEmail[MockEmail_select];

  //console.log(chalk.bgBlue.white("MockEmail_select : "), MockEmail_select);
  //console.log(chalk.bgBlue.white("selectedEmail : "), selectedEmail);

  //Company info
  const companyInfo_MOCK = [
    {
      name_company: "CARBOMB COMPANY LIMITED(TESTER COMPANY)",
      name_company_en: "CARBOMB COMPANY LIMITED(TESTER COMPANY)",
      name_branch: "00001",
      head_office: "0",
      email: selectedEmail ? selectedEmail : "null email",
      address: "TEST 456/78 Nimmanhaemin Road",
      address2: "TEST Floor 3, Tower B",
      id_province: "10",
      id_district: "1002",
      id_subdistrict: "100201",
      postal_code: "10300",
      phone_no: "0635109125",
      fax_no: "0999999999",
      id_tax: "0999999999999",
      createby_id_company: "70",
    },
  ];
  const OrganizationInfo_MOCK = [
    {
      organizationName: "CARBOMB COMPANY LIMITED(TESTER ORG)",
      organizationNameEng: "CARBOMB COMPANY LIMITED(TESTER ORG)",
      org_phoneNumber: "0999999999",
      org_faxNumber: "0999999999",
      org_email: selectedEmail,
      org_website: "https://test_inverzsolutions.com",
      org_logo: "",
      org_address: "TEST 123 ถนนสุขุมวิท แขวงคลองตัน",
      org_address2: "TEST เขตวัฒนา",
      org_province: "10",
      org_district: "1002",
      org_subDistrict: "100201",
      org_postalCode: "10300",
    },
  ];
  const BasicInfo_MOCK = [
    {
      firstName: "Muhummad",
      lastName: "Hijack",
      nickName: "Bang",
      gender: "male",
      birth: "1990-05-15",
      national: 204,
      email: selectedEmail,
      passport: "A12345678",
      address: "123 Main Street",
      address2: "Apt 4B",
      country: 66,
      province: "10",
      district: "1002",
      subDistrict: "100201",
      postalCode: "10300",
      phoneNumber: "0698758547",
    },
  ];
  const paymentMethod_MOCK = {
    name: "Muhummad Hijack",
    number: "5454 5454 5454 5454",
    expiration_month: "11",
    expiration_year: "26",
    security_code: "429",
  };
  const companyInfo = [
    {
      name_company: "",
      name_company_en: "",
      name_branch: "",
      head_office: "",
      email: "",
      address: "",
      address2: "",
      id_province: "",
      id_district: "",
      id_subdistrict: "",
      postal_code: "",
      phone_no: "",
      fax_no: "",
      id_tax: "",
    },
  ];
  const OrganizationInfo = [
    {
      organizationName: "",
      organizationNameEng: "",
      org_phoneNumber: "",
      org_faxNumber: "",
      org_email: "",
      org_website: "",
      org_logo: "",
      org_address: "",
      org_address2: "",
      org_province: "",
      org_district: "",
      org_subDistrict: "",
      org_postalCode: "",
    },
  ];
  const BasicInfo = [
    {
      firstName: "",
      lastName: "",
      nickName: "",
      gender: "",
      birth: "",
      national: "",
      email: "",
      passport: "",
      address: "",
      address2: "",
      country: "",
      province: "",
      district: "",
      subDistrict: "",
      postalCode: "",
      phoneNumber: "",
    },
  ];

  ///left block theme
  const descriptionStyle = {
    //Logo
    logoWidth: "100%",
    logoHeight: "120px",
    logoMaxWidth: "350px",
    logoMaxHeight: "120px",
    titleFont: {
      fontSize: "14px",
      fontWeight: 500,
      color: "rgb(0, 0, 0)",
      fontFamily: "Prompt",
    },
    subtitleFont: {
      fontSize: "14px",
      fontWeight: 200,
      color: "rgb(0, 0, 0)",
      fontFamily: "Prompt",
    },
    detailFont: {
      fontSize: "14px",
      fontWeight: 200,
      color: "rgb(0, 0, 0)",
      fontFamily: "Prompt",
    },
    listFontSize: "12px",
  };

  // สำหรับเปิดปิด Drawer

  const [open, setOpen] = useState("");
  const showDrawer = (t) => {
    setOpen(t);
  };
  const onClose = () => {
    setOpen(false);
  };
  // สำหรับเก็บข้อมูลขั้นตอนการทำงาน
  const dispatch = useDispatch(); // ใช้ dispatch ของ redux
  const location = useLocation(); //ไว้ดึง Params จาก URL

  //////////////////////GET PARAMS///////////////////////////////
  ///////////////////////////////////////////////////////////////
  const queryParams = new URLSearchParams(location.search);
  const project_url = queryParams.get("project");
  const plan_url = queryParams.get("plan");
  const installment_plan_url = queryParams.get("installment_plan");
  const promo_code_url = queryParams.get("promo_code");
  const ref_url = queryParams.get("ref");
  const formRef = useRef(null);
  const currentYear = new Date().getFullYear();
  const { Omise } = window;

  //General
  const [errorsMessage, setErrorsMessage] = useState([]);

  //General แปลงเวลา
  dayjs.extend(utc);
  dayjs.extend(timezone);

  //PKINDEV
  const [pkindev, setPkindev] = useState([]);
  //state
  const [loading, setLoading] = useState(false);
  const [lang, setLang] = useState("en");
  const [companyInfoData, setCompanyInfoData] = useState(companyInfo);
  const [organizationInfoData, setOrganizationInfoData] =
    useState(OrganizationInfo);
  const [basicInfoData, setBasicInfoData] = useState(BasicInfo);
  const [selectPlan, setSelectPlan] = useState("");
  const [pkindev_id, setPkindev_id] = useState("70");

  // const token = queryParams.get("token");
  const [project_id, setProject_id] = useState([]);
  const [id_subscription_plan_table, setId_subscription_plan_table] = useState(
    []
  );
  const [installment_plan, setInstallment_plan] = useState([]);
  const [promo_code, setPromo_code] = useState([]);
  const [ref, setRef] = useState(ref_url);

  // PAYMENT STATE
  const [demo, setDemo] = useState(false);
  const [paymentData, setPaymentData] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [paymentProgress, setPaymentProgress] = useState(0);
  const [paymentEmail, setPaymentEmail] = useState("");
  const [isPaymentEmailVerified, setIsPaymentEmailVerified] = useState(false);

  //Checkbox State
  const [agreementCheckbox, setAgreementCheckbox] = useState(false);
  const [confirmCheckbox, setConfirmCheckbox] = useState(false);
  const [confirmPayment, setConfirmPayment] = useState(false);
  const [sameAddress, setSameAddress] = useState(false);
  const [message, setMessage] = useState("");

  // สำหรับตรวจสอบว่าเลื่อนถึงล่างหรือยัง
  const [isAtBottom, setIsAtBottom] = useState(false);

  //Modal
  // const [openResponsive, setOpenResponsive] = useState(false);
  const [openPaymentProgress, setOpenPaymentProgress] = useState(false);
  const [modalShow, setModalShow] = useState("");
  const handleClose = () => setModalShow("");
  const handleShow = (type) => setModalShow(type);

  ///Set loading
  useEffect(() => {
    setLoading(props.loading);
  }, [props.loading]);

  ///////////////////////////////////////////////////////////////
  //////////////////////HELPER DEVELOPER/////////////////////////
  ///////////////////////////////////////////////////////////////

  function handleMOCK() {
    // 👇 แสดง input prompt ให้ผู้ใช้กรอกหมายเลข (1 หรือ 2)
    const input = prompt("กรุณาเลือกหมายเลขอีเมล (1 - 3):", "1");

    const index = parseInt(input) - 1; // ✅ ปรับให้สอดคล้องกับ array (เริ่มที่ 0)

    if (isNaN(index) || index < 0 || index >= mockEmail.length) {
      alert("❌ กรุณาใส่หมายเลขที่ถูกต้อง (1 - 3)");
      return;
    }

    // ✅ set index ที่ผู้ใช้กรอก
    setMockEmail_select(index);

    console.log(chalk.bgBlue.white("index : "), index);
    console.log(chalk.bgBlue.white("MockEmail_select : "), MockEmail_select);
    console.log(chalk.bgBlue.white("selectedEmail : "), selectedEmail);
    // ✅ ใช้ข้อมูลที่เกี่ยวข้อง
  }

  useEffect(() => {
    console.log(
      chalk.bgGreen.white("📬 MockEmail_select เปลี่ยนค่าเป็น : "),
      MockEmail_select
    );

    if (MockEmail_select !== undefined) {
      setCompanyInfoData(companyInfo_MOCK);
      setOrganizationInfoData(OrganizationInfo_MOCK);
      setBasicInfoData(BasicInfo_MOCK);
      setPaymentMethod(paymentMethod_MOCK);
      setPaymentEmail(mockEmail[MockEmail_select]);
      setIsPaymentEmailVerified(true);
      setAgreementCheckbox(true);
      setConfirmCheckbox(true);
      setConfirmPayment(true);
    }
  }, [MockEmail_select]); // ✅ รันทุกครั้งที่ MockEmail_select เปลี่ยน

  useEffect(() => {
    console.log(chalk.green("Payment Progress : ", paymentProgress));
  }, [paymentProgress]);
  ////////////////////////////////////////////////////////////////
  /////////////////////////////TOKEN//////////////////////////////
  ////////////////////////////////////////////////////////////////

  const [exp_tkn, setExp_tkn] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);
  const [hasRedirected, setHasRedirected] = useState(false);

  // ✅ อัปเดตจาก storage ครั้งแรกและเมื่อ storage เปลี่ยนแปลง
  useEffect(() => {
    const updateExpToken = () => {
      const storedExp = sessionStorage.getItem("guest_token_exp");
      if (storedExp) setExp_tkn(parseInt(storedExp, 10));
    };

    updateExpToken();
    window.addEventListener("storage", updateExpToken);

    return () => window.removeEventListener("storage", updateExpToken);
  }, []);

  useEffect(() => {
    if (!exp_tkn) {
      setTimeLeft(null);
      return;
    }
    const calculateTimeLeft = () => {
      const expirationTime = moment.unix(exp_tkn);
      const currentTime = moment();
      const remainingTime = expirationTime.diff(currentTime, "seconds");

      setTimeLeft(remainingTime > 0 ? remainingTime : 0);
    };

    calculateTimeLeft();

    // 🔔 Interval เปลี่ยนจากทุกวินาทีเป็นทุก 5 วินาที
    const interval = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(interval);
  }, [exp_tkn]);

  // ✅ ตรวจสอบการหมดอายุของ Token และทำการ redirect เพียงครั้งเดียว
  useEffect(() => {
    if (timeLeft === 0 && !hasRedirected) {
      console.log("🛑 Token Expired! Removing...");
      removeToken();
      setHasRedirected(true);

      switch (project_url) {
        case 12:
          window.location.replace("https://smartlawth.com/#pricing");
          break;

        case 15:
          window.location.replace("https://leavehub.info/");
          break;

        case 16:
          window.location.replace("https://rentaru.com/");
          break;

        default:
          window.location.replace("https://pkindev.com/#project");
          break;
      }
    }
  }, [timeLeft, hasRedirected, project_url]);

  // ✅ เรียก API ตรวจสอบ Token เฉพาะเมื่อ Token ใกล้หมดอายุ (น้อยกว่า 1 นาที)
  useEffect(() => {
    if (timeLeft && timeLeft < 60) {
      time_out();
    }
  }, [timeLeft]);

  const formatTimeLeft = (seconds) => {
    if (seconds === null) return "Token expired";

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    let formattedTime = "";
    if (hours > 0) formattedTime += `${hours} ชั่วโมง `;
    if (minutes > 0) formattedTime += `${minutes} นาที `;
    if (secs > 0 || formattedTime === "") formattedTime += `${secs} วินาที`;

    return formattedTime.trim();
  };

  const time_out = async () => {
    console.log(chalk.bgBlue.white("Activate time_out function"));

    let guest_token = sessionStorage.getItem("guest_token");
    let exp_tkn = sessionStorage.getItem("guest_token_exp");

    if (!guest_token || isTokenExpired(exp_tkn)) {
      console.log("🔁 Token missing or expired. Creating new one...");

      try {
        const res_creat_token = await create_token();
        if (res_creat_token?.guest_token) {
          guest_token = res_creat_token.guest_token;
          sessionStorage.setItem("guest_token", guest_token);
        } else {
          console.error("❌ Failed to create token");
          return;
        }
      } catch (error) {
        console.error("❌ Error creating token:", error);
        return;
      }
    }

    try {
      const res_verify = await verify_token(guest_token);
      if (res_verify?.guest_token_exp) {
        exp_tkn = res_verify.guest_token_exp;
        sessionStorage.setItem("guest_token_exp", exp_tkn);
        setExp_tkn(exp_tkn);
      } else {
        removeToken();
      }
    } catch (error) {
      removeToken();
    }
  };

  const isTokenExpired = (exp_tkn) => {
    if (!exp_tkn) return true;
    const expirationTime = moment.unix(exp_tkn);
    return expirationTime.isBefore(moment());
  };

  const removeToken = () => {
    sessionStorage.removeItem("guest_token");
    sessionStorage.removeItem("guest_token_exp");
    alert("Token expired or invalid. Please refresh the page.");
  };

  const create_token = async () => {
    try {
      const respond = await axios.get(
        `${BASE_URL}/subscription/auth/create_token`
      );
      return respond.data;
    } catch (error) {
      console.error("❌ Error fetching token:", error);
      return null;
    }
  };

  const verify_token = async (guest_token) => {
    try {
      const respond = await axios.post(
        `${BASE_URL}/subscription/auth/verify_token`,
        { guest_token }
      );
      return respond.data;
    } catch (error) {
      console.error("❌ Error verifying token:", error);
      return null;
    }
  };
  /////////////////////////////////////////////////////////////
  //////////////////////CONNECT DATABASE///////////////////////
  /////////////////////////////////////////////////////////////

  /// เช็คว่ามี project_url / pkindev_id / plan_url ก่อนดึงข้อมูล
  useEffect(() => {
    const readyToFetch = project_url && pkindev_id && plan_url;

    if (readyToFetch) {
      fetchAllData();
    }
  }, [project_url, pkindev_id, plan_url]);
  /// ดึงข้อมูล Plan ตาม ID / Plan สามารถเปลี่ยนได้ ในหน้า Confirm Plan

  //เช็คว่า Project กับ Plan สัมพันธ์กันหรือไม่
  useEffect(() => {
    setLoading(true);

    const projectPlan = props.projectPlan;

    if (projectPlan.length > 0) {
      const matchedPlan = projectPlan.find(
        (plan) => plan.id_subscription_plan_table === Number(plan_url)
      );

      if (!matchedPlan) {
        console.error("This Package not available");
        setErrorsMessage((prev) => [...prev, "This Package not available"]);
        setModalShow("errorsMessage");
        setLoading(false);
        return;
      }

      // ถ้ามี plan ตรงกัน ก็ตั้งค่าต่าง ๆ ได้เลย
      setSelectPlan(Number(plan_url));
      setProject_id(Number(project_url));
      setId_subscription_plan_table(Number(plan_url));
      setInstallment_plan(installment_plan_url);
      setPromo_code(promo_code_url);
      setRef(ref_url);
    }

    setLoading(false);
  }, [props.projectPlan]);

  useEffect(() => {
    const readyToFetch = selectPlan;

    if (readyToFetch) {
      fetchPlanData(selectPlan);
    }
  }, [selectPlan]);

  //fetchAllData
  const fetchAllData = async () => {
    time_out();

    if (!project_url || !plan_url) {
      toastError("❌ Error: Not found - project or plan");
      return;
    }
    setLoading(true);

    try {
      // ดึงข้อมูลเบื้องต้น
      await Promise.all([
        dispatch(getPkindevRequest({ id_company: pkindev_id })),
        dispatch(getProject_request({ id_project: project_url })),
        dispatch(getProject_Plan_request({ id_project: project_url })),
        dispatch(getCreditBank("both")),
        dispatch(getTermsRequest({ id_project: project_url })),
        dispatch(getPrivacyRequest({ id_project: project_url })),
        dispatch(getRefundRequest({ id_project: project_url })),
      ]);
    } catch (error) {
      console.error("Error fetching data:", error);
      toastError("❌ Error: Fetching data");
    } finally {
      setLoading(false);
    }
  };

  //ดึง plan
  const fetchPlanData = async (planId) => {
    if (!planId) return;
    try {
      await dispatch(
        getSubscription_Plan_Request({ id_subscription_plan_table: planId })
      );
    } catch (error) {
      console.error("Error fetching plan data:", error);
      toastError("❌ Error: Fetching plan data");
    }
  };

  useEffect(() => {
    const plan = props.subscriptionPlanData;
    console.log("plan_________________________", plan);

    if (plan?.price <= 20) {
      setDemo(true);
    } else {
      setDemo(false);
    }
  }, [props.subscriptionPlanData]);

  ///////////////////////////////////////////////////////////
  /////////////////////////STEPPER///////////////////////////
  ///////////////////////////////////////////////////////////

  const [step_process, setStep_process] = useState(0);
  const [steps, setSteps] = useState([]);
  const addNewCompany = texts[lang].addNewCompany;
  const addOrganization = texts[lang].addOrganization;
  const addOwner = texts[lang].addOwner;
  const reconfirmPackage = texts[lang].reconfirmPackage;
  const paymentInformation = texts[lang].paymentInformation;

  useEffect(() => {
    let newSteps = [];
    setLoading(true);
    console.log(chalk.bgBlue.yellow("project_url : "), project_url);

    switch (Number(project_url)) {
      case 12: // LeaveHub * All
        newSteps = [
          addNewCompany,
          addOrganization,
          addOwner,
          reconfirmPackage,
          paymentInformation,
        ];
        break;

      case 15: // LeaveHub * No organization
        newSteps = [
          addNewCompany,
          addOwner,
          reconfirmPackage,
          paymentInformation,
        ];
        break;

      case 16: // Rentaru * All
        newSteps = [
          addNewCompany,
          addOrganization,
          addOwner,
          reconfirmPackage,
          paymentInformation,
        ];
        break;

      default:
        newSteps = [
          addNewCompany,
          addOrganization,
          addOwner,
          reconfirmPackage,
          paymentInformation,
        ];
        break;
    }

    // 🔻 ลบ paymentInformation ถ้า demo เป็น true
    if (demo) {
      newSteps = newSteps.filter((step) => step !== paymentInformation);
    }

    // 🛑 เช็คก่อนว่า steps เดิมกับใหม่เหมือนกันหรือไม่
    const isSame = JSON.stringify(steps) === JSON.stringify(newSteps);

    if (!isSame) {
      console.log("⏩ Set New Steps:", newSteps);
      setSteps(newSteps);
    }

    console.log(chalk.bgCyan.red("current step : "), newSteps);
    setLoading(false);
  }, [project_url, lang, demo]);

  ///////////////////////////////////////////////////////////
  ///////////////////////////lang////////////////////////////
  ///////////////////////////////////////////////////////////
  const toggleLang = () => {
    setLang((prevLang) => (prevLang === "en" ? "th" : "en"));
  };

  ///////////////////////////////////////////////////////////
  //////////////////////toastComponent///////////////////////
  ///////////////////////////////////////////////////////////
  const toastSuccess = (text) => {
    toast.success(text, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "colored",
      style: {
        background: "#6D0B14", // สีแดงเข้ม
        color: "#FFFFFF", // ตัวอักษรสีขาว
      },
      progressStyle: {
        background: "#FFB6C1", // สีชมพูอ่อนให้เข้ากับธีม
      },
    });
  };
  const toastError = (text) => {
    toast.error(text, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "colored",
      style: {
        background: "#A11217", // สีแดงเข้มให้เด่นขึ้น
        color: "#FFFFFF", // ตัวอักษรสีขาว
      },
      progressStyle: {
        background: "#FFC0CB", // สีชมพูอ่อน
      },
    });
  };
  const toastWarning = (text) => {
    toast.warning(text, {
      position: "top-right",
      autoClose: 2000, // ปิดอัตโนมัติใน 2 วินาที
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "colored",
      style: {
        background: "#FFA500", // สีส้มสดใส (เตือน)
        color: "#FFFFFF", // ตัวอักษรสีขาว
      },
      progressStyle: {
        background: "#FFD700", // สีทองอ่อนให้เข้ากับธีม
      },
    });
  };
  /////////////////////////////////////////////////////////////
  //////////////////HANDLE - FUNCTION//////////////////////////
  /////////////////////////////////////////////////////////////
  //สร้าง Contract รายเดือน / รายปี
  function generateContracts(startDateStr, period = "MONTHLY") {
    const contracts = [];

    let currentStart = dayjs(startDateStr);

    for (let i = 0; i < 2; i++) {
      const contractStart = currentStart;
      const contractEnd =
        period === "YEARLY"
          ? contractStart.add(1, "year").subtract(1, "day")
          : contractStart.add(1, "month").subtract(1, "day");

      contracts.push({
        start_date: contractStart.format("YYYY-MM-DD"),
        finish_date: contractEnd.format("YYYY-MM-DD"),
      });

      currentStart = contractEnd.add(1, "day");
    }

    return contracts;
  }
  //กดจ่ายเงิน บันทึกข้อมูล
  const handleSubmit = async () => {
    // setOpenResponsive(false);
    //Modal Progress
    setOpenPaymentProgress(true);
    setPaymentProgress(0);

    //เตรียมข้อมูล
    const projectId = Number(project_url);
    const pkindev_id = props.pkindev?.company?.[0]?.id_company || 70;
    const company = (await companyInfoData?.[0]) || {};
    const organize = organizationInfoData?.[0] || {};
    const admin = (await basicInfoData?.[0]) || {};
    const payment = (await paymentMethod) || {};
    const payment_Email = (await paymentEmail) || "";
    const plan = (await selectPlan) || {};
    const extra_options = await props.subscriptionPlanData.extra_option;
    const plan_data = await props.subscriptionPlanData;
    const project = await props.project;
    const publicKey = props?.pkindev?.payment_connection?.[0]?.credit?.public_key ?? "";

    if (!companyInfoData || !basicInfoData || !paymentMethod) {
      console.error("❌ ข้อมูลบางส่วนขาดหาย!");
      setErrorsMessage((prev) => [...prev, "❌ ข้อมูลบางส่วนขาดหาย"]);
      setModalShow("errorsMessage");
      setLoading(false);
      return;
    }

    ///////////////////////////////////////
    //////////////OMISE*///////////////////
    ///////////////////////////////////////
    const handleError = (msg) => {
      console.error(msg);
      setMessage(msg);
      setErrorsMessage((prev) => [...prev, msg]);
      setModalShow("errorsMessage");
      setLoading(false);
      toastError(`❌ เกิดข้อผิดพลาด : ${msg}`);
    };

    // use handleError
    if (!window.Omise) {
      handleError("❌ Omise.js ยังไม่ได้โหลด");
      return;
    }
    if (!payment_Email) {
      handleError("❌ ไม่พบ อีเมลสำหรับการชำระเงิน!");
      return;
    }
    if (!publicKey) {
      handleError("❌ ไม่พบ Public Key!");
      return;
    }

    ///ข้อมูล สำหรับสร้าง TOKEN Card detail
    const cardDetails = {
      name: payment.name,
      number: payment.number,
      expiration_month: payment.expiration_month,
      expiration_year: payment.expiration_year,
      security_code: payment.security_code,
    };

    //ตั้งค่าวันเริ่มต้น / วันสิ้นสุด / และวันที่รอบบิลถัดไป
    const start_date = dayjs().format("YYYY-MM-DD");
    let endDate = "";
    let nextCharge = "";

    //เช็คว่า Packgage เป็น รายเดือนหรือ รายปี
    if (
      props.subscriptionPlanData?.installment_plan &&
      props.subscriptionPlanData?.minimum_period_time
    ) {
      // จำนวนขั้นต่ำของ Packgage *** แต่ไม่ได้แล้ว
      const period = props.subscriptionPlanData.minimum_period_time;

      if (props.subscriptionPlanData.installment_plan === "MONTHLY") {
        endDate = getEndDate(start_date, period, 0);
        nextCharge = getNextChargeDate(start_date, period, 0);
      } else if (props.subscriptionPlanData.installment_plan === "YEARLY") {
        endDate = getEndDate(start_date, 0, period);
        nextCharge = getNextChargeDate(start_date, 0, period);
      }
    } else {
      // กรณีไม่มีข้อมูล — ใช้ค่าเริ่มต้น 1 เดือน
      endDate = getEndDate(start_date, 1, 0);
      nextCharge = getNextChargeDate(start_date, 1, 0);
    }

    // Omise Charge_data prepare พักข้อมูลรอใช้ใน func - OmiseCustomer_Charg()
    const chargeSetting = {
      id_company: pkindev_id,
      name: payment.name,
      email: payment_Email,
      description: `${project.project_acronym} แพ็กเกจ: ${plan_data.name_subscription_plan} — จ่ายรายเดือน เดือนแรก (${start_date} - ${endDate})`,
      amount: plan_data.price * 100,
      currency: "THB",
    };


    /// Demo Mode
    let scheduledChargeResponse;
    if (demo) {
      console.log("🔁 Demo Mode: ข้ามการชำระเงิน");

      scheduledChargeResponse = {
        status: true,
        data: {
          charge: {
            status: "successful",
            paid: true,
            paid_at: new Date().toISOString(),
            amount: props.subscriptionPlanData.price * 100,
          },
          customer: {
            id: "demo_customer_id",
          },
        },
      };
    } else {
      const token = await card_token(cardDetails);
      scheduledChargeResponse = await OmiseCustomer_Charge(
        token,
        chargeSetting
      );
    }

    // // ส่งไปยัง Backend card_token() ฟังก์ชั่นสำหรับ Token Card ที่ผูกกับ Customer สร้างโดย Omise
    // const token = await card_token(cardDetails);
    // //Charge Omise API ด้วย Token เก็บข้อมูล card และ chargeSetting
    // const scheduledChargeResponse = await OmiseCustomer_Charge(token, chargeSetting );


    //รับ & Check scheduledChargeResponse
    if (scheduledChargeResponse.status) {
      console.log(
        "✅ ตั้งค่าการเรียกเก็บเงินสำเร็จ:",
        scheduledChargeResponse.data
      );
      toastSuccess("✅ สร้างลูกค้า + ผูกบัตร + ตั้ง Schedule สำเร็จ!");
    } else {
      console.error("❌ เกิดข้อผิดพลาด:", scheduledChargeResponse.error);
      toastError(`❌ เกิดข้อผิดพลาด : ${scheduledChargeResponse.error.error}`);
      setErrorsMessage((prev) => [
        ...prev,
        `500 Internal Server Error : เกิดข้อผิดพลาดในการชำระเงิน`,
      ]);
      setModalShow("errorsMessage");

      setLoading(false);
      return;
    }

    //Debugging
    console.log(      "PAYMENT SUCCESS : scheduledChargeResponse:",      scheduledChargeResponse    );

    //พักข้อมูล charge response
    const charge = scheduledChargeResponse.data.charge;

    ///เช็คสถานะการเรียกเก็บเงิน
    const isChargeValid =      charge.status === "successful" && charge.paid === true;

    // แปลงเป็นเวลาไทย และฟอร์แมต
    const paidAtInThailand = dayjs
      .utc(charge.paid_at)
      .tz("Asia/Bangkok")
      .format("YYYY-MM-DD HH:mm:ss");

    //พักข้อมูล Bill_PAYMENT
    const installment_plan = props.subscriptionPlanData?.installment_plan || "";
    const paymentTypeMap = {
      MONTHLY: "month",
      YEARLY: "year",
    };

    const payment_type = paymentTypeMap[installment_plan] || null;

    if (!props.subscriptionPlanData.id_subscription_plan_table) {
      console.error("❌ ไม่พบ id_subscription_plan_table");
      setErrorsMessage((prev) => [
        ...prev,
        "❌ ไม่พบ id_subscription_plan_table",
      ]);
      setModalShow("errorsMessage");
      setLoading(false);
      return;
    }

    // เตรียมข้อมูล อัพเดท Table : pkindev_platform.Bill_Payment;
    //const bill_payment_payload = {
    ///  payment_type,
    //  id_subscription_plan_table:
    //    props.subscriptionPlanData.id_subscription_plan_table,
    //  payment_detail: JSON.stringify(charge),
    //  accept: isChargeValid ? 1 : 0,
    //  id_omise_customer: scheduledChargeResponse.data.customer.id,
    //  next_charge_date: nextCharge,
    //  last_charge_date: paidAtInThailand,
    //  last_charge_status: charge.status,
    //  failure_message: charge.failure_message,
    //};


    const bill_payment_payload = {
      payment_type,
      id_subscription_plan_table: props.subscriptionPlanData.id_subscription_plan_table,
      payment_detail: JSON.stringify(charge),
      accept: 1, // ✅ demo ถือว่า always success
      id_omise_customer: demo ? "demo_customer_id" : scheduledChargeResponse.data.customer.id,
      next_charge_date: nextCharge,
      last_charge_date: paidAtInThailand,
      last_charge_status: charge.status,
      failure_message: demo ? null : charge.failure_message || null,
    };

    /////////////////////////////////////////////////////
    //////////////ADD CUSTOMER PROJECT*//////////////////
    /////////////////////////////////////////////////////

    //เตรียมข้อมูล เพิ่ม Company / Organization / Admin / Bill / Contract แต่ละโปรเจค
    const payloads = {
      id_project: projectId,
      id_subscription_plan_table: plan,
      company: company,
      organization: organize,
      admin: admin,
      extra_options: extra_options,
    };

    //Debugging
    //console.log("📦 Payload:", payloads);

    //
    const apiPaths = {
      12: {
        api_company: {
          path: `${BASE_URL}/smart_law/company/add`,
          method: "POST",

          data: () => {
            return {
              ...payloads,
            };
          },

          status: "",
          error: "",
          result: null,
        },
        api_organization: {
          path: `${BASE_URL}/smart_law/organization/add`,
          method: "POST",
          data: (x) => {
            const id_company = x.api_company?.result?.id_company;
            return {
              ...payloads,
              id_company: id_company,
            };
          },
          status: "",
          error: "",
          result: null,
        },
        api_admin: {
          path: `${BASE_URL}/smart_law/admin/add`,
          method: "POST",
          data: (x) => {
            const id_company = x.api_company?.result?.id_company;
            return {
              ...payloads,
              id_company: id_company,
            };
          },
          status: "",
          error: "",
          result: null,
        },
        api_map_organization: {
          path: `${BASE_URL}/smart_law/admin/map_organization`,
          method: "PUT",

          data: (x) => {
            const id_organization = x.api_organization?.result?.id_organization;
            const id_user = x.api_admin?.result?.id_user;
            return {
              id_organization: id_organization,
              id_user: id_user,
            };
          },
          status: "",
          error: "",
          result: null,
        },
        id_bill: {
          path: `${BASE_URL}/bill/add`,
          method: "POST",

          data: (x) => {
            const id_company = x.api_company?.result?.id_company;
            const id_organization = x.api_organization?.result?.id_organization;
            const id_branch = x.api_organization?.result?.id_branch;

            return {
              id_project: payloads.id_project,
              id_company: id_company,
              id_organization: id_organization,
              id_branch: id_branch,
              main_head: company?.head_office || 0,
            };
          },
          status: "",
          error: "",
          result: null,
        },
        id_bill_payment: {
          path: `${BASE_URL}/billing/payment/add_payment`,
          method: "POST",
          data: (x) => {
            const id_bill = x.id_bill?.result?.id_bill;

            return {
              id_bill: id_bill,
              ...bill_payment_payload,
            };
          },
          status: "",
          error: "",
          result: null,
        },
        bill_user: {
          ///
          path: `${BASE_URL}/subscription/bill_user/add`,
          method: "POST",

          data: (x) => {
            const id_bill = x.id_bill?.result?.id_bill;

            return {
              body1: {
                email: admin.email,
                password: "1234",
                first_name: admin.firstName,
                last_name: admin.lastName,
                gender: admin.gender,
                country_value: admin.country,
                date_of_birth: admin.birth,
                id_passport: admin.passport,
                address: admin.address,
                address2: admin.address2,
                nick_name: admin.nickName,
                idNationality: admin.national,
                id_province: admin.province,
                id_district: admin.district,
                id_subdistrict: admin.subDistrict,
                postal_code: admin.postalCode,
                mobile_no: admin.phoneNumber,
              },
              body4: [`${id_bill}`],
            };
          },
          status: "",
          error: "",
          result: null,
        },
      },
      15: {
        api_company: {
          path: `${BASE_URL}/leave_hub/company/add`,
          method: "POST",
          data: () => {
            return {
              ...payloads,
            };
          },
          status: "",
          error: "",
          result: null,
        },

        api_admin: {
          path: `${BASE_URL}/leave_hub/admin/add`,
          method: "POST",
          data: (x) => {
            const id_company = x.api_company?.result?.id_company;
            console.log(
              chalk.red.white("api_admin :::::::::::::::::::: id_company : "),
              id_company
            );
            return {
              ...payloads,
              id_company: id_company,
            };
          },
          status: "",
          error: "",
          result: null,
        },
        id_bill: {
          path: `${BASE_URL}/bill/add`,
          method: "POST",

          data: (x) => {
            const id_company = x.api_company?.result?.id_company || null;
            const id_organization =
              x.api_organization?.result?.id_organization || null;
            const id_branch = x.api_organization?.result?.id_branch || null;

            return {
              id_project: payloads.id_project,
              id_company: id_company,
              id_organization: id_organization || null,
              id_branch: id_branch || null,
              main_head: company?.head_office || 0,
            };
          },
          status: "",
          error: "",
          result: null,
        },
        id_bill_payment: {
          path: `${BASE_URL}/billing/payment/add_payment`,
          method: "POST",
          data: (x) => {
            const id_bill = x.id_bill?.result?.id_bill;

            return {
              id_bill: id_bill,
              ...bill_payment_payload,
            };
          },
          status: "",
          error: "",
          result: null,
        },
        bill_user: {
          ///
          path: `${BASE_URL}/subscription/bill_user/add`,
          method: "POST",

          data: (x) => {
            const id_bill = x.id_bill?.result?.id_bill;

            return {
              body1: {
                email: admin.email,
                password: "1234",
                first_name: admin.firstName,
                last_name: admin.lastName,
                gender: admin.gender,
                country_value: admin.country,
                date_of_birth: admin.birth,
                id_passport: admin.passport,
                address: admin.address,
                address2: admin.address2,
                nick_name: admin.nickName,
                idNationality: admin.national,
                id_province: admin.province,
                id_district: admin.district,
                id_subdistrict: admin.subDistrict,
                postal_code: admin.postalCode,
                mobile_no: admin.phoneNumber,
              },
              body4: [`${id_bill}`],
            };
          },
          status: "",
          error: "",
          result: null,
        },
      },
      16: {
        api_company: {
          path: `${BASE_URL}/rentaru/company/add`,
          method: "POST",
          data: () => {
            return {
              ...payloads,
            };
          },
          status: "",
          error: "",
          result: null,
        },
        api_organization: {
          path: `${BASE_URL}/rentaru/organization/add`,
          method: "POST",
          data: (x) => {
            const id_company = x.api_company?.result?.id_company;
            return {
              ...payloads,
              id_company: id_company,
            };
          },
          status: "",
          error: "",
          result: null,
        },
        api_admin: {
          path: `${BASE_URL}/rentaru/admin/add`,
          method: "POST",
          data: (x) => {
            const id_organization = x.api_organization?.result?.id_organization;
            const id_company = x.api_company?.result?.id_company;
            return {
              ...payloads,
              id_company: id_company,
              id_organization: id_organization,
            };
          },
          status: "",
          error: "",
          result: null,
        },
        id_bill: {
          path: `${BASE_URL}/bill/add`,
          method: "POST",

          data: (x) => {
            const id_company = x.api_company?.result?.id_company;
            const id_organization = x.api_organization?.result?.id_organization;
            const id_branch = x.api_organization?.result?.id_branch;

            return {
              id_project: payloads.id_project,
              id_company: id_company,
              id_organization: id_organization,
              id_branch: id_branch,
              main_head: company?.head_office || 0,
            };
          },
          status: "",
          error: "",
          result: null,
        },
        id_bill_payment: {
          path: `${BASE_URL}/billing/payment/add_payment`,
          method: "POST",

          data: (x) => {
            const id_bill = x.id_bill?.result?.id_bill;

            return {
              id_bill: id_bill,
              ...bill_payment_payload,
            };
          },
          status: "",
          error: "",
          result: null,
        },
        bill_user: {
          ///
          path: `${BASE_URL}/subscription/bill_user/add`,
          method: "POST",

          data: (x) => {
            const id_bill = x.id_bill?.result?.id_bill;

            return {
              body1: {
                email: admin.email,
                password: "1234",
                first_name: admin.firstName,
                last_name: admin.lastName,
                gender: admin.gender,
                country_value: admin.country,
                date_of_birth: admin.birth,
                id_passport: admin.passport,
                address: admin.address,
                address2: admin.address2,
                nick_name: admin.nickName,
                idNationality: admin.national,
                id_province: admin.province,
                id_district: admin.district,
                id_subdistrict: admin.subDistrict,
                postal_code: admin.postalCode,
                mobile_no: admin.phoneNumber,
              },
              body4: [`${id_bill}`],
            };
          },
          status: "",
          error: "",
          result: null,
        },
      },
    };

    if (!apiPaths[projectId]) {
      console.error("ไม่พบโปรเจกต์");
      setErrorsMessage((prev) => [...prev, `ไม่พบโปรเจกต์`]);
      setModalShow("errorsMessage");
      return;
    }

    // เอาไว้คำนวณ Progress % ของ Api ทั้งหมด และนับว่าสำเร็จไปกี่อันกี่ %
    const totalApis = Object.keys(apiPaths[projectId]).length;
    let completedApis = 0;
    try {
      for (const key of Object.keys(apiPaths[projectId])) {
        const api = apiPaths[projectId][key];
        console.log(`🔄 Sending request to: ${key}`);

        const requestPayload =
          typeof api.data === "function"
            ? api.data(apiPaths[projectId])
            : api.data;

        console.log(
          chalk.bgCyanBright.red(`🔄 Sending requestData to: ${key}`),
          requestPayload
        );

        try {
          const headers = {
            "x-has-accesstoken": sessionStorage.getItem("guest_token"),
          };
          if (!api?.path) {
            console.error(`❌ Missing path in ${key}`);
            setErrorsMessage((prev) => [...prev, `❌ Missing path in ${key}`]);
            setModalShow("errorsMessage");
            continue;
          }
          console.log(`🔗 Calling: ${api.path}`);

          let response;
          switch (api.method) {
            case "GET":
              response = await axios.get(api.path, {
                params: requestPayload,
                headers,
              });
              break;
            case "PUT":
              response = await axios.put(api.path, requestPayload, { headers });
              break;
            case "POST":
            default:
              response = await axios.post(api.path, requestPayload, {
                headers,
              });
              break;
          }

          if (response.data.status === false) {
            api.status = "failed";
            api.error = response.data.message || "Unknown error from API";
            setErrorsMessage((prev) => [
              ...prev,
              `${response.data.message} || "Unknown error from API"`,
            ]);
            setModalShow("errorsMessage");
            throw new Error(`API ${key} failed: ${api.error}`);
          }
          api.status = "completed";

          ///เก็บ respon ไว้ใน result ของแต่ละ api ของ project id นั้น
          api.result = response.data;

          completedApis++;
          const progress = Math.round((completedApis / totalApis) * 90);
          setPaymentProgress(progress);

          console.log(`✅ Completed: ${key}, Progress: ${progress}%`);
        } catch (error) {
          api.status = "failed";
          api.error = error.message;
          console.error(`❌ Error in ${key}:`, api.error);
          setErrorsMessage((prev) => [
            ...prev,
            `❌ Error in ${key}: ${api.error}`,
          ]);
          setModalShow("errorsMessage");
        }
      }
    } catch (err) {
      console.error("Unexpected error during API execution:", err);
    }
    /////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////CREATE  -  CONTRACT/////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////

    const startDateContract = start_date;
    const endDateContract = endDate;

    //Debug
    console.log(
      chalk.bgBlue.white(
        "start-end  :",
        startDateContract,
        "--->",
        endDateContract
      )
    );

    //ฟังชั่นสร้าง Contract ตามวันที่ ขึ้นอยู่กับ installment_plan
    const contractList = generateContracts(
      startDateContract,
      plan_data.installment_plan
    );

    if (!contractList || contractList.length === 0) {
      console.error("ไม่สามารถสร้าง contract list ได้");
      setErrorsMessage((prev) => [
        ...prev,
        `500 Internal Server Error : ไม่สามารถสร้าง contract list ได้`,
      ]);
      setModalShow("errorsMessage");
    }

    console.log("📆", contractList);
    console.log("📦 จำนวนรอบที่จะสร้างสัญญา:", contractList.length);
    let count = 0;

    // วนลูปสร้างสัญญาแบบรายเดือน
    for (const contract of contractList) {
      const charge = scheduledChargeResponse.data.charge;

      // แปลง paid_at ให้เหลือแค่ YYYY-MM-DD
      const paidDate = dayjs(charge.paid_at).format("YYYY-MM-DD");

      // เช็คข้อมูล Charge Paid at ว่ามีการจ่ายเงินแล้ว จะได้ อัพเดท Paid หรือ Pending
      const isMatched =
        paidDate === contract.start_date && charge.status === "successful";

      //Debugg
      console.log(
        "📆",
        contract.start_date,
        " - ",
        contract.finish_date,
        " - ",
        isMatched
      );

      //เตรียมข้อมูล Update Contract Agreement
      const contractData = {
        start_date: contract.start_date,
        period_time: plan_data.installment_plan === "YEARLY" ? 12 : 1, // ถ้า yearly คือ 12 เดือน
        finish_date: contract.finish_date,
        price:
          scheduledChargeResponse.charge?.amount != null
            ? scheduledChargeResponse.charge.amount / 100
            : plan_data.price,
        total_price:
          scheduledChargeResponse.charge?.amount != null
            ? scheduledChargeResponse.charge.amount / 100
            : plan_data.price,
        discount_price: 0,
        remark: `company : ${company.name_company_en}\n${project.project_acronym}-${plan_data.id_subscription_plan_table}-${plan_data.minimum_period_time}`,
        payment_type: "Credit/Debit Cards",
        status_payment: isMatched ? "Paid" : "Pending",
        total_amount:
          scheduledChargeResponse.charge?.amount != null
            ? scheduledChargeResponse.charge.amount / 100
            : plan_data.price,
        id_subscription_plan_table: payloads.id_subscription_plan_table,
        payment_date: contract.start_date,
        id_organization:
          apiPaths[projectId]?.api_organization?.result?.id_organization ||
          null,
        id_project: projectId,
        id_company: apiPaths[projectId]?.api_company?.result?.id_company | null,
      };

      ///Path Api ของ แต่ละโปรเจค
      try {
        const contract_path = {
          12: {
            path: `${BASE_URL}/smart_law/organization/contract_agreement/add`,
          },
          15: {
            path: `${BASE_URL}/leave_hub/company/contract_agreement/add`,
          },
          16: {
            path: `${BASE_URL}/rentaru/organization/contract_agreement/add`,
          },
        };

        //เลือก path ตาม projectId
        const selectedPath = contract_path[projectId]?.path;

        if (!selectedPath) {
          console.log(
            chalk.bgRed.white.underline("Contract : ไม่พบโปรเจกต์ไอดี")
          );

          setErrorsMessage((prev) => [
            ...prev,
            `500 Internal Server Error > ContractFunction : ไม่พบโปรเจกต์ไอดี`,
          ]);
          setModalShow("errorsMessage");

          throw new Error("ContractAgreement Error : ไม่พบโปรเจกต์ไอดี");
        }

        //ติดต่อฐานข้อมูล ดึง Token จาก sessionStorage
        const headers = {
          "x-has-accesstoken": sessionStorage.getItem("guest_token"),
        };

        //Response
        const response = await axios.post(
          `${selectedPath}`,
          { data: { contract: contractData, id_project: projectId } }, // payload
          { headers }
        );

        if (response.data.status !== false) {
          count++;
        }

        if (count === contractList.length) {
          console.log("✅ ✅ เสร็จครบทุกสัญญาแล้วทั้งหมด", count, "รอบ");
        }
      } catch (error) {
        console.error(
          "❌ 500 Internal Server Error : สร้างสัญญาไม่สำเร็จ: ",
          error.message
        );

        setErrorsMessage((prev) => [
          ...prev,
          `500 Internal Server Error > ContractFunction : สร้างสัญญาไม่สำเร็จ : ${error.message}`,
        ]);
        setModalShow("errorsMessage");
      }
    }

    console.log(
      "🚀 All requests completed (with or without errors):",
      apiPaths[projectId]
    );

    const allCompleted = Object.values(apiPaths[projectId]).every(
      (api) => api.status === "completed" && count === contractList.length
    );

    if (allCompleted) {
      console.log("✅ All requests completed successfully!");
      setPaymentProgress(100);
      toastSuccess("✅ สร้างข้อมูลสำเร็จ!");
    } else {
      console.error("❌ Some requests failed. Check logs for details.");
      toastError("❌ มีข้อผิดพลาด กรุณาตรวจสอบข้อมูลอีกครั้ง");
      setErrorsMessage((prev) => [
        ...prev,
        `500 Internal Server Error : มีข้อผิดพลาด`,
      ]);
      setModalShow("errorsMessage");
    }
  };

  const updateQueryParams = (params) => {
    const url = new URL(window.location);

    // อัปเดตค่าของแต่ละ parameter
    Object.keys(params).forEach((key) => {
      if (params[key] === null) {
        url.searchParams.delete(key); // ลบ param ถ้าค่าเป็น null
      } else {
        url.searchParams.set(key, params[key]); // ตั้งค่าค่าใหม่
      }
    });

    // อัปเดต URL โดยไม่ต้องโหลดหน้าใหม่
    window.history.pushState({}, "", url);
  };
  const handleNext = () => {
    console.log("step_process", step_process);
    /////////////////////////////////////////////////
    ////////////////////​COMAPANY/////////////////////
    if (steps[step_process] === addNewCompany) {
      const companyValidationErrors = validateCompanyInfo(companyInfoData); // ตรวจสอบข้อมูล

      if (Object.keys(companyValidationErrors).length > 0) {
        console.log("พบข้อผิดพลาด:", companyValidationErrors);
        toastWarning(texts[lang].company_check_field);

        return; // หยุดการทำงานถ้ามี error
      }

      if (companyErrors && !agreementCheckbox) {
        toastWarning(texts[lang].agreementCheckbox);
        return; // หยุดการทำงานถ้าไม่ได้เช็คช่อง Agreement
      }
    }

    ////////////////////////////////////////////////////
    ////////////////////Organization/////////////////////
    if (steps[step_process] === addOrganization) {
      const organizationValidationErrors =
        validateOrganizationInfo(organizationInfoData); // ตรวจสอบข้อมูล

      if (Object.keys(organizationValidationErrors).length > 0) {
        console.log("พบข้อผิดพลาด:", organizationValidationErrors);
        toastWarning(texts[lang].company_check_field);

        return; // หยุดการทำงานถ้ามี error
      }
    }

    if (steps[step_process] === addOwner) {
      const basicInfoValidationErrors = validateBasicInfo(basicInfoData); // ตรวจสอบข้อมูล

      if (Object.keys(basicInfoValidationErrors).length > 0) {
        console.log("พบข้อผิดพลาด:", basicInfoValidationErrors);
        toastWarning(texts[lang].company_check_field);

        return; // หยุดการทำงานถ้ามี error
      }
    }
    if (steps[step_process] === reconfirmPackage && !confirmCheckbox) {
      toastWarning(texts[lang].confirmPlan);

      return; // หยุดการทำงานถ้าไม่ได้เช็คช่อง Agreement
    }
    // เพิ่ม step_process ได้เฉพาะเมื่อผ่านเงื่อนไข
    setStep_process((prevStep) => prevStep + 1);
  };
  const handleBack = () => {
    setStep_process(step_process - 1);

    if (step_process === 0 && !agreementCheckbox) {
    }
  };

  /////////////////////////////////////////////////////////////
  ////////////////////////Check feild//////////////////////////
  /////////////////////////////////////////////////////////////
  //errors field Error
  const [companyErrors, setCompanyErrors] = useState({});
  const [organizationErrors, setOrganizationErrors] = useState({});
  const [basicInfoErrors, setBasicInfoErrors] = useState({});
  const [touchedFields, setTouchedFields] = useState({});
  const [stepValid, setStepValid] = useState(false);

  const handleBlur = (fieldName) => {
    setTouchedFields((prev) => ({
      ...prev,
      [fieldName]: true,
    }));
  };

  //useEffect เพื่อ validate auto ทันทีที่ผู้ใช้กรอก
  useEffect(() => {
    const currentStep = steps[step_process];

    let errors = {};
    if (currentStep === addNewCompany) {
      errors = validateCompanyInfo(companyInfoData);
      console.log("Company Errors", errors);
    } else if (currentStep === addOrganization) {
      errors = validateOrganizationInfo(organizationInfoData);
      console.log("Organization Errors", errors);
    } else if (currentStep === addOwner) {
      errors = validateBasicInfo(basicInfoData);
      console.log("Basic Info Errors", errors);
    }

    setStepValid(Object.keys(errors).length === 0);
  }, [
    companyInfoData,
    organizationInfoData,
    basicInfoData,
    step_process,
    steps,
    lang,
  ]);

  const touchAllFields = () => {
    const allTouched = {};
    Object.keys(companyInfoData[0]).forEach((field) => {
      allTouched[field] = true;
    });
    setTouchedFields(allTouched);
    validateCompanyInfo(companyInfoData); // รี validate
  };

  //Check feild Company
  function validateCompanyInfo(data) {
    const company = data[0];
    const rules = {
      name_company: {
        test: (v) => v?.trim().length >= 3,
        msg: "ชื่อบริษัทต้องมีอย่างน้อย 3 ตัวอักษร",
      },
      name_company_en: {
        test: (v) => v?.trim().length >= 3,
        msg: "ชื่อบริษัท (ภาษาอังกฤษ) ต้องมีอย่างน้อย 3 ตัวอักษร",
      },
      name_branch: { test: (v) => !!v, msg: "ชื่อสาขาไม่ถูกต้อง" },
      email: {
        test: (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v),
        msg: "อีเมลไม่ถูกต้อง",
      },
      address: {
        test: (v) => v?.trim().length >= 5,
        msg: "ที่อยู่ต้องมีอย่างน้อย 5 ตัวอักษร",
      },
      address2: {
        test: (v) => v?.trim().length >= 5,
        msg: "ที่อยู่ต้องมีอย่างน้อย 5 ตัวอักษร",
      },
      id_province: { test: (v) => !!v, msg: "กรุณาเลือกจังหวัด" },
      id_district: { test: (v) => !!v, msg: "กรุณาเลือกอำเภอ" },
      id_subdistrict: { test: (v) => !!v, msg: "กรุณาเลือกตำบล" },
      postal_code: {
        test: (v) => /^\d{5}$/.test(v),
        msg: "รหัสไปรษณีย์ต้องเป็นตัวเลข 5 หลัก",
      },
      phone_no: {
        test: (v) => /^(\+\d{1,3})?\d{9,10}$/.test(v),
        msg: "หมายเลขโทรศัพท์ต้องมี 9-10 หลัก",
      },
      fax_no: {
        test: (v) => /^\d{9,10}$/.test(v),
        msg: "หมายเลขแฟกซ์ต้องเป็นตัวเลข 9-10 หลัก",
      },
      id_tax: {
        test: (v) => /^\d{13}$/.test(v),
        msg: "เลขประจำตัวผู้เสียภาษีต้องเป็นตัวเลข 13 หลัก",
      },
    };

    const errors = Object.entries(rules).reduce((acc, [key, rule]) => {
      if (!rule.test(company[key])) acc[key] = rule.msg;
      return acc;
    }, {});

    // เพิ่ม valid เสมอ

    setCompanyErrors(errors);
    return errors; // คืนค่า errors กลับไป
  }
  ///Check feild Organization
  function validateOrganizationInfo(data) {
    const organization = data[0];

    const rules = {
      organizationName: {
        test: (v) => v?.trim().length >= 3,
        msg: "ชื่อองค์กรต้องมีอย่างน้อย 3 ตัวอักษร",
      },
      organizationNameEng: {
        test: (v) => v?.trim().length >= 3,
        msg: "ชื่อองค์กร (ภาษาอังกฤษ) ต้องมีอย่างน้อย 3 ตัวอักษร",
      },
      org_phoneNumber: {
        test: (v) => /^(\+\d{1,3})?\d{9,10}$/.test(v),
        msg: "หมายเลขโทรศัพท์ต้องมี 9-10 หลัก",
      },
      org_faxNumber: {
        test: (v) => /^\d{9,10}$/.test(v),
        msg: "หมายเลขแฟกซ์ต้องเป็นตัวเลข 9-10 หลัก",
      },
      org_email: {
        test: (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v),
        msg: "อีเมลไม่ถูกต้อง",
      },

      org_website: {
        test: (v) =>
          typeof v === "string" &&
          v.trim() !== "" && // ห้ามเป็นค่าว่าง
          /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w-./?%&=]*)?$/i.test(v),
        msg: "URL เว็บไซต์ไม่ถูกต้อง หรือห้ามเว้นว่าง",
      },

      org_logo: {
        test: (v) => !v || /^data:image\/(png|jpeg|jpg);base64,/.test(v),
        msg: "กรุณาอัปโหลดโลโก้ที่เป็นรูปภาพ (PNG, JPG)",
      },

      org_address: {
        test: (v) => v?.trim().length >= 5,
        msg: "ที่อยู่ต้องมีอย่างน้อย 5 ตัวอักษร",
      },
      org_address2: {
        test: (v) => v?.trim().length >= 5,
        msg: "ที่อยู่ต้องมีอย่างน้อย 5 ตัวอักษร",
      },
      org_province: { test: (v) => !!v, msg: "กรุณาเลือกจังหวัด" },
      org_district: { test: (v) => !!v, msg: "กรุณาเลือกอำเภอ" },
      org_subDistrict: { test: (v) => !!v, msg: "กรุณาเลือกตำบล" },
      org_postalCode: {
        test: (v) => /^\d{5}$/.test(v),
        msg: "รหัสไปรษณีย์ต้องเป็นตัวเลข 5 หลัก",
      },
    };

    const errors = Object.entries(rules).reduce((acc, [key, rule]) => {
      if (!rule.test(organization[key])) acc[key] = rule.msg;
      return acc;
    }, {});

    setOrganizationErrors(errors);
    return errors; // คืนค่า errors กลับไป
  }
  // Check field BasicInfo
  function validateBasicInfo(data) {
    const basic = data[0];
    const rules = {
      firstName: {
        test: (v) => v?.trim().length >= 2,
        msg: "ชื่อจริงต้องมีอย่างน้อย 2 ตัวอักษร",
      },
      lastName: {
        test: (v) => v?.trim().length >= 2,
        msg: "นามสกุลต้องมีอย่างน้อย 2 ตัวอักษร",
      },
      nickName: { test: (v) => !!v, msg: "กรุณากรอกชื่อเล่น" },
      gender: {
        test: (v) => ["male", "female"].includes(v),
        msg: "กรุณาเลือกเพศ",
      },
      birth: {
        test: (v) => /^\d{4}-\d{2}-\d{2}$/.test(v),
        msg: "วันเกิดต้องอยู่ในรูปแบบ YYYY-MM-DD",
      },
      national: { test: (v) => !!v, msg: "กรุณากรอกสัญชาติ" },
      email: {
        test: (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v),
        msg: "อีเมลไม่ถูกต้อง",
      },
      passport: {
        test: (v) => /^[A-Z0-9]{6,13}$/.test(v), // ต้องมีค่าตลอด และต้องมี 6-13 ตัวอักษร
        msg: "หมายเลขพาสปอร์ตต้องมีตัวอักษรหรือตัวเลข 6-13 หลัก",
      },
      address: {
        test: (v) => v?.trim().length >= 5,
        msg: "ที่อยู่ต้องมีอย่างน้อย 5 ตัวอักษร",
      },
      address2: {
        test: (v) => (v ? v.trim().length >= 5 : true), // ถ้าไม่มีค่าให้ผ่าน
        msg: "ที่อยู่ต้องมีอย่างน้อย 5 ตัวอักษร",
      },
      country: { test: (v) => !!v, msg: "กรุณากรอกประเทศ" },
      province: { test: (v) => !!v, msg: "กรุณากรอกจังหวัด" },
      district: { test: (v) => !!v, msg: "กรุณากรอกอำเภอ" },
      subDistrict: { test: (v) => !!v, msg: "กรุณากรอกตำบล" },
      postalCode: {
        test: (v) => /^\d{5}$/.test(v),
        msg: "รหัสไปรษณีย์ต้องเป็นตัวเลข 5 หลัก",
      },
      phoneNumber: {
        test: (v) => !!v && /^(\+\d{1,3})?\d{9,10}$/.test(v), // ห้ามว่าง + ต้องตรงกับ regex
        msg: "หมายเลขโทรศัพท์ต้องมี 9-10 หลัก",
      },
    };

    const errors = Object.entries(rules).reduce((acc, [key, rule]) => {
      if (!rule.test(basic[key])) acc[key] = rule.msg;
      return acc;
    }, {});

    setBasicInfoErrors(errors);
    return errors; // คืนค่า errors กลับไป
  }
  /////////////////////////////////////////////////////////////
  ///////////////////////////OMISE/////////////////////////////
  /////////////////////////////////////////////////////////////

  //คำนวณ วันที่รอบบิลถัดไป
  const getNextChargeDate = (startDate, monthsToAdd = 0, yearsToAdd = 0) => {
    return dayjs(startDate)
      .add(yearsToAdd, "year")
      .add(monthsToAdd, "month")
      .format("YYYY-MM-DD");
  };

  //คำนวณ วันที่สิ้นสุดรอบบิลถัดไป
  const getEndDate = (startDate, monthsToAdd, yearsToAdd) => {
    return dayjs(startDate)
      .add(yearsToAdd, "year")
      .add(monthsToAdd, "month")
      .subtract(1, "day") // ให้จบ "ก่อนวันเริ่ม" ของงวดถัดไป
      .format("YYYY-MM-DD");
  };

  const card_token = async (cardDetails) => {
    return new Promise((resolve, reject) => {
      if (!window.Omise) {
        console.error("❌ Omise.js ยังไม่ได้โหลด");
        reject("❌ Omise.js ยังไม่ได้โหลด");
        return;
      }
      const publicKey =
        props?.pkindev?.payment_connection?.[0]?.credit?.public_key ?? null;
      if (!publicKey) {
        console.error("❌ ไม่พบ Public Key");
        toastError("❌ ไม่พบ Public Key");
        reject("❌ ไม่พบ Public Key");

        return;
      }
      Omise.setPublicKey(publicKey);
      Omise.createToken(
        "card",
        {
          name: cardDetails.name,
          number: cardDetails.number,
          expiration_month: cardDetails.expiration_month,
          expiration_year: cardDetails.expiration_year,
          security_code: cardDetails.security_code,
        },
        (statusCode, response) => {
          if (statusCode === 200) {
            console.log("✅ Token:", response.id);
            resolve(response.id); // ✅ Return Token
          } else {
            console.error("❌ Error:", response);
            //reject("❌ เกิดข้อผิดพลาดในการสร้าง Token");

            setErrorsMessage((prev) => [
              ...prev,
              `500 Internal Server Error > card_tokenFunction : เกิดข้อผิดพลาดในการสร้าง Token`,
            ]);
            setModalShow("errorsMessage");
          }
        }
      );
    });
  };

  const OmiseCustomer_Charge = async (token, schedule) => {
    // แปลง start_date เป็น Object Date
    const startDate = new Date(schedule.start_date);
    const dayOfMonth = startDate.getDate(); // วันที่ของ start_date
    const monthOfYear = startDate.getMonth() + 1; // เดือนของ start_date (JavaScript นับเดือนจาก 0)

    // กำหนดค่าของ `on` ตามเงื่อนไข period เช่นจ่ายทุกๆวันที่ 1 จของเดือน หรือ วันที่ 1 เดือน 1 ของปี
    const onConfig =
      schedule.period === "month"
        ? { days_of_month: [dayOfMonth] } // ✅ รายเดือน: วันที่ตาม start_date
        : { days_of_month: [dayOfMonth], months: [monthOfYear] }; // ✅ รายปี: วันที่ + เดือน ตาม start_date

    // Data for Omise only
    const data = {
      id_company: schedule.id_company,
      name: schedule.name,
      email: schedule.email,
      description: schedule.description,
      amount: schedule.amount,
      currency: schedule.currency,
      token: token, // ✅ ใช้ Token ที่สร้างจาก Omise
      schedule: {
        every: schedule.every,
        period: schedule.period,
        start_date: schedule.start_date,
        end_date: schedule.end_date,
        on: onConfig, // ✅ ใช้ค่าที่กำหนดจาก onConfig
      },
    };

    // ส่งข้อมูลไปยัง Backend
    try {
      const response = await axios.post(
        `${BASE_URL}/omise/createCharge/create_customer_charge`,
        data
      );

      console.log("✅ Send to Backend - Success :", response.data);
      setMessage("✅ สร้างลูกค้า + ผูกบัตร + ตั้ง Schedule สำเร็จ!");

      // ✅ Return status true พร้อมข้อมูลจาก backend
      return { status: true, data: response.data };
    } catch (error) {
      console.error("❌ Error:", error);
      setMessage("❌ เกิดข้อผิดพลาดในการส่งข้อมูลไปยัง Backend");
      // ❌ Return status false พร้อม error message
      return { status: false, error: error.response?.data || error.message };
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      fluid
      className="d-flex flex-column"
      style={{
        minHeight: "100vh", // ให้มีความสูงขั้นต่ำเท่ากับ 100% ของหน้าจอ
        backgroundImage: `url(${backgroundSvg})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <GlobalStyle />

      <ToastContainer />
      {/* ปุ่มเปลี่ยนภาษา */}
      <div
        style={{
          position: "absolute",
          top: "10px", // ระยะห่างจากขอบบน
          right: "10px", // ระยะห่างจากขอบขวา
          zIndex: 1050,
        }}
      >
        <div className="d-flex align-items-center gap-5">
          {/* ปุ่มแสดงเวลา Session */}
          <Button
            variant="primary"
            className="text-white fw-bold px-4 py-2 mr-2"
            style={{
              background: "linear-gradient(to right, #a8c0a0, #7f9c82)", // Gradient Blue
              border: "none",
              borderRadius: "30px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              transition: "all 0.3s ease",
            }}
          >
            {timeLeft !== null
              ? `เวลาการใช้งาน : ${formatTimeLeft(timeLeft)}`
              : "Token expired"}
          </Button>

          {/* ปุ่มเปลี่ยนภาษา */}
          <Button
            variant="light"
            className="d-flex align-items-center px-4 py-2"
            style={{
              borderRadius: "30px",
              background: "#f8f9fa",
              color: "#333",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              transition: "all 0.3s ease",
            }}
            onClick={toggleLang}
          >
            <SwapOutlined className="me-2 text-lg" />
            {lang === "en" ? "TH" : "EN"}
          </Button>
        </div>
      </div>

      <div className="d-none">
        {/* กล่องข้อมูลบัตรทดสอบวางที่มุมขวาบน */}
        <div
          className="position-fixed top-0 end-0 m-3 bg-light rounded shadow p-3 w-20"
          style={{ zIndex: 1050 }}
        >
          <h5 className="text-primary">Test Credit Cards</h5>
          <ul className="list-unstyled mb-0">
            <li>
              <strong>Visa:</strong>
              <br></br>
              <span>4111 1111 1111 1111 ------(บัตรทดสอบมาตรฐานของ Visa)</span>
            </li>
            <li>
              <strong>MasterCard:</strong> <br></br>
              <span>
                5555 5555 5555 4444 --------(บัตรทดสอบมาตรฐานของ MasterCard)
              </span>
            </li>
            <li>
              <strong>American Express (AMEX):</strong> -------- <br></br>
              <span>3782 822463 10005 --------(บัตร AMEX - 15 หลัก)</span>
            </li>
            <li>
              <strong>JCB:</strong> <br></br>
              <span>3566 1111 1111 1113 -------(บัตรทดสอบของ JCB)</span>
            </li>
          </ul>
        </div>
      </div>

      <Button
        type="default"
        className="floating-button"
        style={{
          position: "fixed",
          top: "10px",
          left: "10px",
          borderRadius: "8px",
          backgroundColor: "white",
          color: "#333",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          padding: "8px 16px",
          fontWeight: "bold",
          border: "1px solid #ddd",
          zIndex: "1000",
          transition: "all 0.3s ease-in-out",
        }}
        onMouseOver={(e) => {
          e.target.style.backgroundColor = "#f5f5f5";
          e.target.style.boxShadow = "0px 6px 12px rgba(0, 0, 0, 0.15)";
        }}
        onMouseOut={(e) => {
          e.target.style.backgroundColor = "white";
          e.target.style.boxShadow = "0px 4px 6px rgba(0, 0, 0, 0.1)";
        }}
        onClick={() => showDrawer("dev")}
      >
        Dev Tools <MenuUnfoldOutlined />
      </Button>

      <Button
        type="default"
        className="floating-button"
        style={{
          position: "fixed",
          top: "50px",
          left: "10px",
          borderRadius: "8px",
          backgroundColor: "white",
          color: "#333",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          padding: "8px 16px",
          fontWeight: "bold",
          border: "1px solid #ddd",
          zIndex: "1000",
          transition: "all 0.3s ease-in-out",
        }}
        onMouseOver={(e) => {
          e.target.style.backgroundColor = "#f5f5f5";
          e.target.style.boxShadow = "0px 6px 12px rgba(0, 0, 0, 0.15)";
        }}
        onMouseOut={(e) => {
          e.target.style.backgroundColor = "white";
          e.target.style.boxShadow = "0px 4px 6px rgba(0, 0, 0, 0.1)";
        }}
        onClick={() => showDrawer("omise")}
      >
        Omise Controllers <MenuUnfoldOutlined />
      </Button>

      <Button
        type="default"
        className="floating-button"
        style={{
          position: "fixed",
          top: "90px",
          left: "10px",
          borderRadius: "8px",
          backgroundColor: "white",
          color: "#333",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          padding: "8px 16px",
          fontWeight: "bold",
          border: "1px solid #ddd",
          zIndex: "1000",
          transition: "all 0.3s ease-in-out",
        }}
      >
        Loading Status : {loading ? "Loading" : "Not Loading"}
      </Button>

      <Button
        type="default"
        className="floating-button"
        style={{
          position: "fixed",
          top: "130px",
          left: "10px",
          borderRadius: "8px",
          backgroundColor: "white",
          color: "#333",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          padding: "8px 16px",
          fontWeight: "bold",
          border: "1px solid #ddd",
          zIndex: "1000",
          transition: "all 0.3s ease-in-out",
        }}
      >
        Props.Loading Status : {props.loading ? "Loading" : "Not Loading"}
      </Button>

      <Button
        type="default"
        className="floating-button"
        style={{
          position: "fixed",
          top: "170px",
          left: "10px",
          borderRadius: "8px",
          backgroundColor: "white",
          color: "#333",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          padding: "8px 16px",
          fontWeight: "bold",
          border: "1px solid #ddd",
          zIndex: "1000",
          transition: "all 0.3s ease-in-out",
        }}
      >
        Demo : {demo ? "True" : "false"}
      </Button>

      <Drawer
        title="Dev Tools"
        onClose={onClose}
        open={open === "dev" ? true : false}
        placement="left"
      >
        <h5 className="text-primary d-flex ">
          {/* ภาษาไทย <br />
            English<br /> */}
          //LeaveHub 15 , 48 <br />
          //SML 12 , 35 <br />
          //RTR 16 , <br />
        </h5>
        <h5 className="text-primary d-flex ">
          Current : {step_process} <br />
        </h5>
        {/* <h5 className="text-primary d-flex ">
          Current Step Name <br />+{steps[step_process]}
        </h5> */}

        <p>
          console.log(chalk.green('ข้อความสีเขียว')); //
          console.log(chalk.red.bold('ข้อความสีแดงและหนา')); //
          console.log(chalk.yellow.underline('ข้อความสีเหลืองพร้อมขีดเส้นใต้'));
          console.log(chalk.bgBlue.white('พื้นหลังน้ำเงิน ตัวอักษรสีขาว'));
        </p>

        {/* ใช้ flex-column และกำหนดปุ่มเป็นวงกลม */}

        <h1 className="text-primary d-flex "> Navigate </h1>
        <div className="d-flex flex-column">
          {[0, 1, 2, 3, 4].map((num) => (
            <Button
              key={num}
              onClick={() => setStep_process(num)}
              className="p-0 d-flex align-items-center justify-content-center bg-black text-white"
              style={{
                width: "100%",
                height: "40px",
                fontSize: "10px",
                lineHeight: "1",
                padding: "0",
                marginBottom: "5px",
              }}
            >
              {num + 1} {steps[num]}
            </Button>
          ))}

          <h1 className="text-primary d-flex"> Console </h1>
          <Button
            className="mt-0"
            onClick={() => {
              console.log("steps_______________________", steps);
              console.log("companyInfoData_____________", companyInfoData);
              console.log(
                "organizationInfoData________ ",
                organizationInfoData
              );
              console.log("basicInfoData_______________", basicInfoData);
              console.log("paymentMethod_______________", paymentMethod);
              console.log("companyErrors_______________", companyErrors);
              console.log("Org Error___________________", organizationErrors);
              console.log("Basic Error_________________", basicInfoErrors);
            }}
          >
            LOG
          </Button>

          <Button className="mt-2" onClick={handleMOCK}>
            MOCK ALL DATA
          </Button>
        </div>
      </Drawer>

      <Drawer
        title="OMISE"
        onClose={onClose}
        open={open === "omise" ? true : false}
        placement="left"
      >
        <h5 className="text-primary d-flex ">OMISE</h5>
        <div className="d-flex flex-column">
          <h1 className="text-primary d-flex"> Omise Controllers </h1>

          <button onClick={""} disabled={loading}>
            {loading ? "กำลังดำเนินการ..." : "สร้าง Token และส่ง API"}
          </button>
          {message && <p>{message}</p>}
        </div>
      </Drawer>

      {/* Header */}
      <header
        className="w-100"
        style={{ height: "60px", backgroundColor: "transparent" }}
      ></header>

      {/* Main content */}

      <Row className="flex-grow-1 justify-content-center align-items-center">
        <Col className="d-flex justify-content-center">
          <Card
            className="custom-card shadow-lg border-0 mx-auto"
            style={{
              width: "100%", // ความกว้างเต็มจอภายใน container
              maxWidth: "1357px", // จำกัดความกว้างสูงสุด

              //maxHeight: "100%",
              borderRadius: "25px",
              overflowX: "auto", // เพิ่มการเลื่อนในแนวนอนหากเนื้อหาเกิน
            }}
          >
            <style jsx>{`
              @media (min-width: 992px) {
                .custom-card {
                  max-height: calc(100vh - 120px);
                }
              }

              @media (max-width: 991px) {
                .custom-card {
                  height: 100%;
                }
              }
            `}</style>
            <Card.Body
              className="p-4"
              style={{
                minHeight: "calc(100vh - 120px)", // ให้ Card.Body สูงเต็ม viewport หักลบ Header/Footer
              }}
            >
              <div className="d-flex flex-column flex-lg-row justify-content-between gap-3 h-100">
                {/* Block ซ้าย */}

                <div
                  //key={index}
                  className="p-3 d-flex flex-column justify-content-start align-items-center"
                  style={{
                    flexBasis: "433px",
                    backgroundColor: "rgb(238, 243, 233)",
                    borderRadius: "12.5px",
                    height: "100%", // ขยายความสูงให้เต็ม Card.Body
                  }}
                >
                  {props.project.logo ? (
                    <img
                      className="m-1"
                      src={props.project.logo.url || pkindev_logo_text}
                      alt="logo_text"
                      style={{
                        width: descriptionStyle.logoWidth, // ความกว้างเต็ม
                        maxWidth: descriptionStyle.logoMaxWidth, // จำกัดขนาดสูงสุด
                        height: descriptionStyle.logoHeight, // ปรับขนาดความสูงอัตโนมัติเพื่อรักษาอัตราส่วน
                      }}
                    />
                  ) : (
                    <Skeleton.Image
                      style={{
                        width: descriptionStyle.logoWidth, // ความกว้างเต็ม
                        maxWidth: descriptionStyle.logoMaxWidth, // จำกัดขนาดสูงสุด
                        height: descriptionStyle.logoHeight, // ปรับขนาดความสูงอัตโนมัติเพื่อรักษาอัตราส่วน
                      }}
                    />
                  )}
                  <span
                    className="mt-3 px-3 py-2 rounded"
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                      textAlign: "center",
                      color: "#333",
                      backgroundColor: "#f8f9fa",
                      border: "1px solid #ddd",
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.05)",
                      display: "inline-block",
                      minWidth: "200px",
                    }}
                  >
                    {props.project?.name_project &&
                    props.project.name_project.trim() !== "" ? (
                      props.project.name_project
                    ) : props.project?.name_project === "" ? (
                      "Inverz Solutions CO.,LTD"
                    ) : (
                      <Skeleton.Input
                        active
                        size="default"
                        style={{ width: 200 }}
                      />
                    )}
                  </span>

                  {/* <hr
                    className="w-100 mt-3"
                    style={{
                      borderTop: "2px solid rgba(0, 0, 0, 0.2)", // เส้นคั่นบางและโปร่งแสง
                      width: "70%", // กำหนดความกว้างของเส้น
                    }}
                  /> */}

                  <Divider style={{ borderColor: "#ccc" }} />

                  {/* {package}------------------------------------------------- */}
                  <div
                    className="d-flex justify-content-between align-items-center"
                    style={{
                      width: "100%", // กำหนดให้ยืดเต็มความกว้าง
                      color: "rgb(0, 0, 0)",
                    }}
                  >
                    <span
                      className="mb-0"
                      style={{
                        ...descriptionStyle.titleFont,
                      }}
                    >
                      {texts[lang].Package}
                    </span>{" "}
                    {/* ลบ margin-bottom */}
                    <span
                      className="d-inline-block "
                      style={{
                        ...descriptionStyle.detailFont,
                      }}
                    >
                      {props.subscriptionPlanData.name_subscription_plan ||
                        "N/A"}
                    </span>
                  </div>

                  {/* {Minimum}------------------------------------------------- */}
                  <div
                    className="d-flex justify-content-between align-items-center"
                    style={{
                      width: "100%", // กำหนดให้ยืดเต็มความกว้าง
                      color: "rgb(0, 0, 0)",
                    }}
                  >
                    <span
                      className="mb-0"
                      style={{
                        ...descriptionStyle.titleFont,
                      }}
                    >
                      Minimum period
                    </span>{" "}
                    {/* ลบ margin-bottom */}
                    <span
                      className="mb-0"
                      style={{
                        ...descriptionStyle.detailFont,
                      }}
                    >
                      {props.subscriptionPlanData.minimum_period_time
                        ? `${props.subscriptionPlanData.minimum_period_time} ${
                            props.subscriptionPlanData?.installment_plan ===
                            "YEARLY"
                              ? "Year"
                              : "Month"
                          }`
                        : "N/A"}
                    </span>
                  </div>

                  {/* Description Section------------------------------------------------- */}
                  <div
                    className="d-flex flex-column justify-content-center align-items-center"
                    style={{
                      width: "100%", // กำหนดให้ยืดเต็มความกว้าง
                      color: "rgb(0, 0, 0)",
                    }}
                  >
                    <span
                      className="mb-0"
                      style={{
                        alignSelf: "flex-start", // ชิดซ้าย
                        ...descriptionStyle.titleFont,
                      }}
                    >
                      {texts[lang].Description}
                    </span>

                    <PerfectScrollbar
                      options={{ suppressScrollX: true }}
                      onScrollY={(container) => {
                        const isAtBottom =
                          container.scrollTop + container.clientHeight >=
                          container.scrollHeight;
                        setIsAtBottom(isAtBottom); // อัปเดตสถานะว่าเลื่อนถึงล่างหรือยัง
                      }}
                      style={{
                        width: "100%",
                        maxHeight: "150px",
                        overflowY: "scroll",
                        boxShadow: isAtBottom
                          ? "none"
                          : "box-shadow: inset 0px -5px 5px rgba(0, 0, 0, 0.2);", // ลด spread ให้เงาไม่เกินขอบข้าง
                      }}
                    >
                      <div className="w-100">
                        {props.subscriptionPlanData?.subscription_plan_detail
                          ?.length > 0 ? (
                          props.subscriptionPlanData.subscription_plan_detail.map(
                            (detail, i) => (
                              <div
                                key={i}
                                className="border-bottom py-2 text-start"
                                style={{
                                  fontSize: descriptionStyle.listFontSize,
                                  width: "100%",
                                  paddingLeft: "16px",
                                  paddingRight: "16px",
                                }}
                              >
                                <li>{detail || "N/A"}</li>
                              </div>
                            )
                          )
                        ) : (
                          <Skeleton />
                        )}
                      </div>
                    </PerfectScrollbar>
                  </div>

                  {/* {Price} */}
                  <div
                    className="d-flex justify-content-between align-items-center"
                    style={{
                      width: "100%", // กำหนดให้ยืดเต็มความกว้าง
                      color: "rgb(0, 0, 0)",
                    }}
                  >
                    <span
                      className="mb-0"
                      style={{
                        ...descriptionStyle.titleFont,
                      }}
                    >
                      {texts[lang].Price}
                    </span>{" "}
                    {/* ลบ margin-bottom */}
                    <span
                      className="mb-0"
                      style={{
                        ...descriptionStyle.detailFont,
                      }}
                    >
                      {props.subscriptionPlanData?.price
                        ? `${props.subscriptionPlanData?.price} bath / ${
                            props.subscriptionPlanData?.installment_plan ===
                            "YEARLY"
                              ? "Year"
                              : "Month"
                          }`
                        : "N/A"}
                    </span>
                  </div>

                  {/* <hr
                    className="w-100 mt-3"
                    style={{
                      borderTop: "2px solid rgba(0, 0, 0, 0.2)", // เส้นคั่นบางและโปร่งแสง
                      width: "70%", // กำหนดความกว้างของเส้น
                    }}
                  /> */}

                  <Divider style={{ borderColor: "#ccc" }} />

                  {/* {Promocode} */}
                  <div
                    className="d-flex flex-column justify-content-center align-items-center mb-2"
                    style={{
                      width: "100%", // กำหนดให้ยืดเต็มความกว้าง
                      color: "rgb(0, 0, 0)",
                    }}
                  >
                    <span
                      className="mb-0"
                      style={{
                        alignSelf: "flex-start", // ชิดซ้าย
                        ...descriptionStyle.titleFont,
                      }}
                    >
                      {texts[lang].Promocode}
                    </span>
                    {/* แก้ไขให้ container ยืดเต็มความกว้าง */}
                    <div
                      className="w-100"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginBottom: "8px",
                      }}
                    >
                      <Form.Control
                        type="text"
                        placeholder="Promo Code"
                        value={promo_code || ""}
                        style={{
                          height: "41px", // กำหนดความสูงเป็น 41px
                          fontSize: "14px", // ขนาดฟอนต์ภายใน input
                          borderRadius: "8px", // ความโค้งมุม 8px
                        }}
                      />

                      <Button variant="light" className="apply-button">
                        ใช้โค้ดส่วนลด
                      </Button>
                    </div>
                  </div>

                  {/* {REF} */}
                  <div
                    className="d-flex flex-column justify-content-center align-items-center mb-2"
                    style={{
                      width: "100%", // กำหนดให้ยืดเต็มความกว้าง
                      color: "rgb(0, 0, 0)",
                    }}
                  >
                    <span
                      className="mb-0"
                      style={{
                        alignSelf: "flex-start", // ชิดซ้าย
                        ...descriptionStyle.titleFont,
                      }}
                    >
                      {texts[lang].Reference_Code}
                    </span>
                    {/* แก้ไขให้ container ยืดเต็มความกว้าง */}
                    <div className="w-100">
                      <Form.Control
                        type="text"
                        placeholder="Promo Code"
                        value={ref || ""}
                        style={{
                          height: "41px", // กำหนดความสูงเป็น 41px
                          fontSize: "14px", // ขนาดฟอนต์ภายใน input
                          borderRadius: "8px", // ความโค้งมุม 8px
                        }}
                      />
                    </div>
                  </div>

                  {/* {Discount} */}
                  <div
                    className="d-flex justify-content-between align-items-center mb-2"
                    style={{
                      width: "100%", // กำหนดให้ยืดเต็มความกว้าง
                      color: "rgb(0, 0, 0)",
                    }}
                  >
                    <span
                      className="mb-0"
                      style={{
                        ...descriptionStyle.titleFont,
                      }}
                    >
                      {texts[lang].Discount}(
                      {props.subscriptionPlanData.discount
                        ? `- ${props.subscriptionPlanData.discount} bath`
                        : "N/A"}
                      )
                    </span>{" "}
                    {/* ลบ margin-bottom */}
                    <span
                      className="mb-0"
                      style={{
                        ...descriptionStyle.detailFont,
                      }}
                    >
                      {props.subscriptionPlanData.discount
                        ? `- ${props.subscriptionPlanData.discount} bath`
                        : "N/A"}
                    </span>
                  </div>

                  <Divider style={{ borderColor: "#ccc" }} />

                  {/* {total} */}
                  <div
                    className="d-flex justify-content-between align-items-center"
                    style={{
                      width: "100%", // กำหนดให้ยืดเต็มความกว้าง
                      color: "rgb(0, 0, 0)",
                    }}
                  >
                    <span
                      className="mb-0"
                      style={{
                        fontSize: "20px", // ขนาดฟอนต
                        color: "rgb(0, 0, 0)",
                      }}
                    >
                      {texts[lang].Total}
                    </span>{" "}
                    {/* ลบ margin-bottom */}
                    <span
                      className="mb-0"
                      style={{
                        fontSize: "15px", // ขนาดฟอนต
                        color: "rgb(0, 0, 0)",
                        fontWeight: 400, // medium น้ำหนักฟอนต์ใน Poppins คือ 500
                      }}
                    >
                      {props.subscriptionPlanData.price
                        ? `${props.subscriptionPlanData.price} bath`
                        : "N/A"}
                    </span>
                  </div>
                </div>

                {/* Block ขวา */}

                <div
                  className="p-1 flex-grow-1 d-flex flex-column"
                  style={{
                    backgroundColor: "white",
                    borderRadius: "12.5px",
                    height: "100%",
                    overflowX: "hidden", // ป้องกันการเลื่อนในแนวนอน
                    //maxWidth: "876px",
                    flexBasis: "876px",
                  }}
                >
                  <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <Box
                      sx={{
                        width: "100%",
                        padding: { xs: "0px", sm: "0px" },
                        //
                      }}
                    >
                      <Stepper
                        activeStep={step_process}
                        alternativeLabel
                        sx={{
                          "& .MuiStepIcon-root": {
                            fontSize: {
                              xs: "24px", // ขนาดไอคอนเล็กบนมือถือ
                              sm: "32px",
                              md: "40px",
                            },
                          },
                          "& .MuiStepLabel-label": {
                            fontSize: {
                              xs: "10px", // ฟอนต์เล็กบนมือถือ
                              sm: "14px",
                              md: "16px",
                            },

                            color: "#333", // สีของฟอนต์
                            textAlign: "center", // จัดให้อยู่กึ่งกลาง
                          },
                        }}
                      >
                        {steps.map((label) => (
                          <Step key={label}>
                            <StepLabel>
                              {label === steps[step_process] ? (
                                <Text strong className="text-danger">
                                  {label}
                                </Text>
                              ) : (
                                <Text type="secondary">{label}</Text>
                              )}
                            </StepLabel>
                          </Step>
                        ))}
                      </Stepper>
                    </Box>
                  </ThemeProvider>

                  {/* FORM */}

                  {steps[step_process] === addNewCompany && (
                    <>
                      {/* <h4 className="mt-5 mb-0 ml-4 font-semibold tracking-wide text-gray-800">
                        {texts[lang].Company_Information}
                      </h4> */}

                      <PerfectScrollbar
                        className="p-0 m-0"
                        style={{ width: "100%", height: "100%" }}
                      >
                        {companyInfoData.length > 0 && (
                          <CompanyInfoForm
                            companyInfoData={companyInfoData}
                            setCompanyInfoData={setCompanyInfoData}
                            lang={lang}
                            ref={formRef}
                            loading={loading}
                            companyErrors={companyErrors}
                            handleBlur={handleBlur}
                            touchedFields={touchedFields}
                          />
                        )}
                      </PerfectScrollbar>
                    </>
                  )}

                  {steps[step_process] === addOrganization && (
                    <>
                      <PerfectScrollbar
                        className="p-0 m-0"
                        style={{ width: "100%", height: "100%" }}
                      >
                        {organizationInfoData.length > 0 && (
                          <OrganizationForm
                            organizationInfoData={organizationInfoData}
                            setOrganizationInfoData={setOrganizationInfoData}
                            sameAddress={sameAddress}
                            setSameAddress={setSameAddress}
                            lang={lang}
                            organizationErrors={organizationErrors}
                            handleBlur={handleBlur}
                            touchedFields={touchedFields}
                          />
                        )}
                      </PerfectScrollbar>
                    </>
                  )}

                  {steps[step_process] === addOwner && (
                    <>
                      <PerfectScrollbar
                        className="p-0 m-0"
                        style={{ width: "100%", height: "100%" }}
                      >
                        {basicInfoData.length > 0 && (
                          <BasicInformationForm
                            basicInfoData={basicInfoData}
                            setBasicInfoData={setBasicInfoData}
                            //option address
                            selectProvinceOption={props.selectProvinceOption}
                            selectDistrictOption={props.selectDistrictOption}
                            selectSubDistrictOption={
                              props.selectSubDistrictOption
                            }
                            lang={lang}
                            basicInfoErrors={basicInfoErrors}
                            handleBlur={handleBlur}
                            touchedFields={touchedFields}
                          />
                        )}
                      </PerfectScrollbar>
                    </>
                  )}
                  {steps[step_process] === reconfirmPackage && (
                    <>
                      <h4 className="mt-5 mb-0 ml-4 font- tracking-wide text-gray-800">
                        Reconfirm Your Plan
                      </h4>
                      <PerfectScrollbar
                        className="p-0 m-0"
                        style={{ width: "100%", height: "100%" }}
                      >
                        <CardPlan
                          packageData={props.projectPlan}
                          selectPlan={selectPlan}
                          setSelectPlan={setSelectPlan}
                        />
                      </PerfectScrollbar>
                    </>
                  )}
                  {steps[step_process] === paymentInformation && (
                    <>
                      <h4 className="mt-5 mb-0 ml-4 font-weight-boldd">
                        <CreditCardFilled /> CREDIT/DEBIT CARD
                      </h4>

                      <PerfectScrollbar
                        className="p-0 m-0"
                        style={{ width: "100%", height: "100%" }}
                      >
                        <PaymentForm
                          paymentData={paymentData}
                          setPaymentData={setPaymentData}
                          paymentMethod={paymentMethod}
                          paymentEmail={paymentEmail}
                          setIsPaymentEmailVerified={setIsPaymentEmailVerified}
                          confirmPayment={confirmPayment}
                          setPaymentMethod={setPaymentMethod}
                          setConfirmPayment={setConfirmPayment}
                          setPaymentEmail={setPaymentEmail}
                          selectCreditBank={props.selectCreditBank}
                          BASE_URL={BASE_URL}
                          lang={lang}
                        />
                      </PerfectScrollbar>
                    </>
                  )}

                  <div style={{ marginTop: "auto" }}>
                    <Divider style={{ borderColor: "#ccc", margin: 10 }} />

                    {/* Footer ชิดขอบล่าง */}
                    {/* <div className="m-0"> */}
                    <div className="container mt-auto">
                      <div className="row align-items-center justify-content-between gy-3">
                        {/* Checkbox and Terms */}
                        <div className="col-12 col-lg-9 d-flex flex-column flex-md-row align-items-center gap-2">
                          {steps[step_process] === addNewCompany && (
                            <Form.Check
                              type="checkbox"
                              id="agreementCheckbox"
                              className="text-center text-md-start"
                              onChange={(e) =>
                                setAgreementCheckbox(e.target.checked)
                              }
                              checked={agreementCheckbox}
                              label={
                                <>
                                  {texts[lang].label1}{" "}
                                  <a
                                    href="#"
                                    className="text-primary"
                                    variant="link"
                                    onClick={() => handleShow("terms")}
                                  >
                                    {texts[lang].terms}
                                  </a>
                                  ,{" "}
                                  <a
                                    href="#"
                                    className="text-primary"
                                    variant="link"
                                    onClick={() => handleShow("privacy")}
                                  >
                                    {texts[lang].privacy}
                                  </a>
                                  , {texts[lang].label2}{" "}
                                  <a
                                    href="#"
                                    className="text-primary"
                                    variant="link"
                                    onClick={() => handleShow("refund")}
                                  >
                                    {texts[lang].refund}
                                  </a>
                                  .
                                </>
                              }
                            />
                          )}

                          {steps[step_process] === reconfirmPackage && (
                            <Form.Check
                              type="checkbox"
                              id="agreementPackage"
                              className="text-center text-md-start"
                              onChange={(e) =>
                                setConfirmCheckbox(e.target.checked)
                              }
                              checked={confirmCheckbox}
                              label={
                                <>I confirm my selection of this package.</>
                              }
                            />
                          )}
                        </div>

                        {/* Action Buttons */}
                        <div className="col-12 col-lg-3 d-flex justify-content-center justify-content-lg-end gap-3">
                          {step_process > 0 && (
                            <Button
                              variant="outline-secondary"
                              className="rounded-pill px-5 mr-2"
                              onClick={handleBack}
                            >
                              {texts[lang].backBtn}
                            </Button>
                          )}

                          {step_process >= 0 &&
                            step_process < steps.length - 1 &&
                            (stepValid ? (
                              <Button
                                variant="danger"
                                className="rounded-pill px-5"
                                onClick={handleNext}
                              >
                                {texts[lang].nextBtn}
                              </Button>
                            ) : (
                              <Button
                                variant="danger"
                                className="rounded-pill px-5 bg-red-300 border-0 text-white"
                                disabled
                              >
                                {texts[lang].nextBtn}
                              </Button>
                            ))}

                          {step_process === steps.length - 1 && (
                            <Button
                              variant="danger"
                              className="rounded-pill px-5"
                              onClick={() => {
                                if (!paymentEmail) {
                                  toastError("กรุณากรอกอีเมลของคุณ");
                                  return;
                                }
                                const emailPattern =
                                  /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                if (!emailPattern.test(paymentEmail)) {
                                  toastError("รูปแบบอีเมลไม่ถูกต้อง");
                                  return;
                                }

                                handleSubmit();
                              }}
                              disabled={
                                !confirmPayment ||
                                !paymentEmail ||
                                !isPaymentEmailVerified
                              }
                              // disabled={!isPaymentEmailVerified}
                            >
                              {texts[lang].submitBtn}
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* subscription data project */}
      {/* Footer */}
      <footer
        className="w-100 text-center"
        style={{
          height: "60px",
          backgroundColor: "transparent",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <medium className="text-muted">
          Copyright {currentYear} © Inverz Solutions Co., Ltd.
        </medium>
      </footer>
      <SpinnerLoading modal={props.loading} />

      {/* Terms and Conditions Modal */}
      <Modal
        className=""
        open={modalShow === "terms"} // ✅ เปลี่ยน `show` เป็น `open`
        onCancel={handleClose} // ✅ ใช้ `onCancel` แทนการปิด Modal
        title={"ข้อตกลงและเงื่อนไข / Terms and Conditions"}
        width={{
          xs: "90%",
          sm: "80%",
          md: "70%",
          lg: "60%",
          xl: "50%",
          xxl: "70%",
        }}
        footer={[
          <Button
            key="close"
            onClick={handleClose}
            variant="outline-secondary"
            className="fw-bold rounded-3 px-4 py-2"
            style={{
              borderWidth: "2px",
              fontSize: "16px",
            }}
          >
            ACCEPT
          </Button>,
        ]}
        centered // ✅ จัด Modal ให้อยู่กึ่งกลาง
      >
        <div
          className="sarabun-text"
          style={{ maxHeight: "60vh", overflowY: "auto" }} // ✅ ใช้ `overflowY` แทน Bootstrap `overflow-auto`
          dangerouslySetInnerHTML={{
            __html: (
              props.terms?.[0]?.description || "<p>No Terms Available</p>"
            ).replace(/style="[^"]*"/g, ""), // ✅ ลบ inline style ออก
          }}
        />
      </Modal>

      {/* Privacy Policy Modal */}
      <Modal
        className=""
        open={modalShow === "privacy"} // ✅ เปลี่ยน `show` เป็น `open`
        onCancel={handleClose} // ✅ ใช้ `onCancel` แทนการปิด Modal
        title={"แนวทางปฏิบัติเกี่ยวกับความเป็นส่วนตัว / Privacy Policy"}
        width={{
          xs: "90%",
          sm: "80%",
          md: "70%",
          lg: "60%",
          xl: "50%",
          xxl: "70%",
        }}
        footer={[
          <Button
            key="close"
            onClick={handleClose}
            variant="outline-secondary"
            className="fw-bold rounded-3 px-4 py-2"
            style={{
              borderWidth: "2px",
              fontSize: "16px",
            }}
          >
            ACCEPT
          </Button>,
        ]}
        centered // ✅ จัด Modal ให้อยู่กึ่งกลาง
      >
        <div
          className="sarabun-text"
          style={{ maxHeight: "60vh", overflowY: "auto" }} // ✅ ใช้ `overflowY` แทน Bootstrap `overflow-auto`
          dangerouslySetInnerHTML={{
            __html: (
              props.privacy?.[0]?.description ||
              "<p>No Privacy Policy Available</p>"
            ).replace(/style="[^"]*"/g, ""), // ✅ ลบ inline style ออก
          }}
        />
      </Modal>

      {/* Refund Policy Modal style={ModalStyle}*/}

      <Modal
        className=""
        open={modalShow === "refund"} // ✅ เปลี่ยน `show` เป็น `open`
        onCancel={handleClose} // ✅ ใช้ `onCancel` แทนการปิด Modal
        title={"นโยบายการคืนเงิน / Refund Policy"}
        width={{
          xs: "90%",
          sm: "80%",
          md: "70%",
          lg: "60%",
          xl: "50%",
          xxl: "70%",
        }}
        footer={[
          <Button
            key="close"
            onClick={handleClose}
            variant="outline-secondary"
            className="fw-bold rounded-3 px-4 py-2"
            style={{
              borderWidth: "2px",
              fontSize: "16px",
            }}
          >
            ACCEPT
          </Button>,
        ]}
        centered // ✅ จัด Modal ให้อยู่กึ่งกลาง
      >
        <div
          className="sarabun-text"
          style={{ maxHeight: "60vh", overflowY: "auto" }} // ✅ ใช้ `overflowY` แทน Bootstrap `overflow-auto`
          dangerouslySetInnerHTML={{
            __html: (
              props.refund?.[0]?.description ||
              "<p>No Refund Policy Available</p>"
            ).replace(/style="[^"]*"/g, ""), // ✅ ลบ inline style ออก
          }}
        />
      </Modal>

      {/* ///TIME OUT MODAL */}
      <Modal
        open={modalShow === "timeout"} // ✅ เปลี่ยน `show` เป็น `open`
        footer={null} // ✅ เอา footer ออกให้เหมือนเดิม
        closable={false} // ✅ ไม่ให้มีปุ่มปิด
        centered // ✅ จัดให้อยู่ตรงกลางหน้าจอ
      >
        <p className="text-center">Your session has expired. Redirecting...</p>
      </Modal>

      {/* ///Error Modal */}
      <Modal
        open={modalShow === "errorsMessage"}
        footer={null}
        closable={false}
        centered
        style={{
          borderRadius: 12,
          overflow: "hidden",
        }}
        styles={{
          body: {
            backgroundColor: "#ffffff",
            padding: 24,
          },
        }}
      >
        <h2 style={{ color: "#dc2626", textAlign: "center", marginBottom: 16 }}>
          ⚠️ พบข้อผิดพลาด
        </h2>

        <div
          style={{ maxHeight: "240px", overflowY: "auto", padding: "0 1rem" }}
        >
          {errorsMessage.map((message, index) => (
            <p
              key={index}
              style={{
                color: "#dc2626",
                textAlign: "center",
                fontWeight: 500,
                marginBottom: 8,
              }}
            >
              {message}
            </p>
          ))}
        </div>

        <div style={{ textAlign: "center", marginTop: 24 }}>
          <button
            onClick={() => {
              setModalShow(null);
              setErrorsMessage([]);
              window.location.reload();
            }}
            style={{
              backgroundColor: "#dc2626",
              color: "#fff",
              border: "none",
              padding: "8px 24px",
              borderRadius: "8px",
              fontWeight: "bold",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
              cursor: "pointer",
            }}
          >
            ตกลง
          </button>
        </div>
      </Modal>

      {/* PROGESS */}
      <Modal
        centered
        open={openPaymentProgress}
        closable={false} // ซ่อนปุ่มปิด (X)
        footer={null} // ไม่มีปุ่ม OK หรือ Cancel
        width={{
          xs: "90%",
          sm: "80%",
          md: "70%",
          lg: "60%",
          xl: "50%",
          xxl: "40%",
        }}
        bodyStyle={{
          //minHeight: "500px",
          overflowY: "auto",
          padding: "15px", // ให้มีระยะขอบที่เหมาะสม
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* หัวข้อ */}

        {paymentProgress === 0 && <h2>กำลังเตรียมการ</h2>}
        {paymentProgress > 0 && paymentProgress < 100 && (
          <h2>กำลังชำระเงิน โปรดรอสักครู่ ....</h2>
        )}
        {paymentProgress === 100 && <h2>ทำรายการเสร็จสิ้น</h2>}

        <Divider />

        {/* จัดให้อยู่ตรงกลาง */}
        <Flex vertical align="center" gap="middle" style={{ width: "100%" }}>
          {paymentProgress < 0 || paymentProgress > 100 ? (
            <>
              <Progress
                percent={paymentProgress}
                status="exception"
                strokeColor={{ from: "#108ee9", to: "#87d068" }}
              />
            </>
          ) : (
            <>
              {" "}
              <Progress
                percent={paymentProgress}
                status="active"
                strokeColor={{
                  from: "#108ee9",
                  to: "#87d068",
                }}
              />
            </>
          )}

          <Typography.Text type="secondary">
            กรุณาอย่าปิดหน้านี้จนกว่าจะเสร็จสิ้น
          </Typography.Text>
        </Flex>
      </Modal>
    </Container>
  );
};

const mapStateToProps = (state) => {
  console.log("ReduxState:", state);

  return {
    //pkindev
    pkindev: state.scriptionPlan.pkindev,
    //PROJECT
    project: state.scriptionPlan.project,
    //PROJECT PLAN
    projectPlan: state.scriptionPlan.projectPlan,
    companyData: state.scriptionPlan.companyData,
    companyProjectMapData: state.scriptionPlan.companyProjectMapData,
    subscriptionData: state.scriptionPlan.subscriptionData,
    subscriptionPlanData: state.scriptionPlan.subscriptionPlanData,
    loading: state.scriptionPlan.loading,
    error: state.scriptionPlan.error,
    //Terms and Conditions Privacy Policy Refund Policy
    terms: state.scriptionPlan.terms,
    privacy: state.scriptionPlan.privacy,
    refund: state.scriptionPlan.refund,

    //province district subdistrict Option
    selectProvinceOption: state.scriptionPlan.provinceOption,
    selectDistrictOption: state.scriptionPlan.districtOption,
    selectSubDistrictOption: state.scriptionPlan.subdistrictOption,

    //***SETTING***//
    //Issuer Bank
    selectCreditBank: state.settings.selectCreditBank,
  };
};

const mapDispatchToProps = {
  //***pkindev***//-
  getPkindevRequest,
  getCompanyPkindev,
  //***PROJECT***//
  getProject_request,
  //***PROJECT PLAN***//
  getSubscription_Plan_Request,
  getProject_Plan_request,
  //***creditbank***//
  getCreditBank,
  //***Terms and Conditions Privacy Policy Refund Policy***//
  getTermsRequest,
  getPrivacyRequest,
  getRefundRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(Subscription);
